{
  "versionSwitch": {
    "current": "Current",
    "draft": "Draft",
    "live": "Live Edit"
  },
  "noItems": "No items",
  "error": "An error occurred!",
  "tutorial": "Tutorial",
  "navigation": {
    "newRelease": {
      "title": "Crew builder (Beta) now available!",
      "description1": "Click ",
      "here": "here",
      "description2": " to learn more!"
    },
    "login": "Log in",
    "changePassword": "Change password",
    "logout": "Logout",
    "menu": "Menu",
    "foreman": "Field",
    "office": "Office",
    "fieldWorkers": "Fieldworkers",
    "fieldUser": "Field",
    "crewMember": "Crew members",
    "equipment": "Equipment",
    "schedules": "Your schedule",
    "requests": "Job requests",
    "other": "Other jobs",
    "all": "All jobs",
    "archived": "Archived",
    "hotSeat": "Hot Seat",
    "onDeck": "On Deck",
    "workload": "Calendar",
    "map": "Map",
    "jobs": "Jobs",
    "resources": "Resources",
    "builders": "Builders",
    "companies": "Companies",
    "inventory": "Inventory",
    "dashboards": "Dashboards",
    "admins": "Admins",
    "tenants": "Tenants",
    "workflows": "Workflows",
    "tutorial": "Tutorial",
    "notifications": "Notifications",
    "push": {
      "info": "To receive push notifications about scheduled jobs you have to grant us permission to do so",
      "action": "Enable push notifications",
      "confirmed": "Push notifications enabled"
    },
    "restore": {
      "tooltip": "Reactivate user"
    },
    "impersonate": {
      "title": "Impersonating: <bold>{{company}} - {{user}}</bold> ({{role}})",
      "tooltip": "The Impersonate action is not available because this user does not currently have access to the service",
      "action": "Back to Admin Panel"
    },
    "update": {
      "title": "New version available",
      "description": "Please update your app to continue:"
    }
  },
  "drawer": {
    "workload": {
      "add": {
        "title": "Create new job",
        "job": {
          "task": "Schedule first task (optional)",
          "addTasks": "Add tasks",
          "additional": "Additional details",
          "workflow": "Workflow details"
        }
      },
      "displayOptions": {
        "title": "Display options"
      },
      "filters": {
        "title": "Filters",
        "titleWithCount": "Filters ({{count}})",
        "tabs": {
          "job": "Jobs",
          "people": "Resources"
        },
        "showMore": "Show more ({{count}})",
        "showLess": "Show less",
        "noResults": "No results.",
        "noFiltersApplied": "No filters applied",
        "selectAll": "Select all",
        "selectAllCount": "{{count}} of {{total}}",
        "sections": {
          "divisions": {
            "title": "Job divisions",
            "description": "Shows jobs in these divisions on the calendar.",
            "noDivision": "No division"
          },
          "workflows": {
            "title": "Workflows",
            "description": "Shows jobs using these workflows on the calendar.",
            "byDivision_one": "Showing workflows in your selected division.",
            "byDivision_other": "Showing workflows in your selected divisions."
          },
          "taskTypes": {
            "title": "Tasks",
            "description": "Shows only these tasks on the calendar.",
            "byWorkflow_one": "Showing tasks in your selected workflow.",
            "byWorkflow_other": "Showing tasks in your selected workflows.",
            "bySpecialty_one": "Showing tasks of your selected specialty.",
            "bySpecialty_other": "Showing tasks of your selected specialties."
          },
          "taskSpecialties": {
            "title": "Task specialties",
            "description": "Shows tasks that require these specialties on the calendar.",
            "byWorkflow_one": "Showing specialties in your selected workflow.",
            "byWorkflow_other": "Showing specialties in your selected workflows.",
            "byDivision_one": "Showing specialties in your selected division.",
            "byDivision_other": "Showing specialties in your selected divisions."
          },
          "statuses": {
            "title": "Schedule statuses",
            "description": "Narrows the calendar by where each schedule sits in the scheduling process."
          },
          "alerts": {
            "title": "Schedule alerts",
            "description": "Shows schedules with active warnings or urgent alerts."
          },
          "builders": {
            "title": "Builders",
            "description": "Narrows the calendar to jobs for these builders."
          },
          "projectManagers": {
            "title": "Project Managers",
            "description": "Narrows the calendar to jobs with these project managers."
          },
          "coordinators": {
            "title": "Project Coordinators",
            "description": "Narrows the calendar to jobs with these project coordinators."
          },
          "resourceDivisions": {
            "title": "Resource divisions",
            "description": "Shows people and equipment in these divisions."
          },
          "resourceSpecialties": {
            "title": "Resource specialties",
            "description": "Shows people and equipment with these specialties."
          },
          "fieldUsers": {
            "title": "Field users",
            "description": "Adds these field users to the calendar, whether or not they have matching work.",
            "hiddenChip": "Field Users hidden"
          },
          "crewMembers": {
            "title": "Crew members",
            "description": "Adds these crew members to the calendar, whether or not they have matching work.",
            "hiddenChip": "Crew Members hidden"
          },
          "equipment": {
            "title": "Equipment",
            "description": "Adds this equipment to the calendar, whether or not it has matching work.",
            "hiddenChip": "Equipment hidden"
          }
        }
      },
      "scheduler": {
        "title": "Schedule {{taskName}} - {{jobTitle}}",
        "crewMembers": "Crew ({{count}}):",
        "assigned": "Assigned to",
        "placeholder": "Unassigned",
        "date": "Date",
        "time": "Time",
        "taskNotes": "Task notes",
        "timeMode": {
          "label": "Time mode",
          "custom": "Custom",
          "fullDay": "Full day",
          "default": "Default"
        },
        "applyToAllDays": "Apply to all days ({{count}})",
        "days": "days"
      }
    }
  },
  "tabs": {
    "manualConcreteOrder": "Manual",
    "concreteDirectOrder": "Concrete direct order",
    "job": "Job",
    "dayOff": "Day off",
    "specialties": "Ready to schedule",
    "jobs": "Jobs",
    "fieldUser": "Field users",
    "crewMember": "Crew members",
    "details": "Details",
    "permit": "Permit",
    "contacts": "Contacts",
    "notes": "Notes",
    "comments": "Comments"
  },
  "invitation": {
    "accept": "Accept your invitation",
    "info": "Set a password for your account"
  },
  "workflowDetails": {
    "new": "Create new workflow",
    "update": "Edit {{name}}"
  },
  "jobDetails": {
    "new": "Create new job",
    "update": "Edit {{name}}"
  },
  "createJobWorkflow": {
    "new": "Add workflow to {{name}}",
    "update": "Edit {{name}}"
  },
  "contact": {
    "new": "New external contact",
    "add": "New external contact",
    "edit": "Edit external contact",
    "removeConfirmation": "Are you sure you want to remove {{contact}} from external contact list?",
    "unassignFromGroup": {
      "title": "Unassign contact from group",
      "description": "Are you sure you want to unassign {{contact}} from {{group}} group? From now on, this person will stop receiving information about this task"
    },
    "changingMainContact": {
      "title": "Changing the main contact",
      "description": "Are you sure you want to change the main contact for this group? From now on, this person will be responsible for confirming tasks."
    }
  },
  "material": {
    "add": "Add material",
    "edit": "Edit material",
    "unit": {
      "tons": "Tons",
      "bars": "Bars",
      "other": "Other"
    }
  },
  "schedule": {
    "requirements": {
      "crew_member": {
        "title": "Crew"
      },
      "needed": "needed",
      "assigned": "{{count}} assigned",
      "need": "Need"
    },
    "team": "Schedule {{team}} team",
    "noTeam": "Schedule without team",
    "multiDay": {
      "for": "for",
      "unit": {
        "day": "day",
        "days": "days",
        "workdays": "workdays"
      },
      "ends": "Ends",
      "increase": "Add day",
      "decrease": "Remove day",
      "workWeekends": "Work weekends:",
      "saturday": "Sat",
      "sunday": "Sun",
      "startDayTurnedOn": "{{day}} turned on because the job starts {{short}}.",
      "dayOf": "Day {{day}} of {{total}}",
      "add": "+ Add",
      "addDays": "Days to add",
      "copyPreview": "New days copy this day:",
      "noForeman": "No foreman",
      "crewCount_one": "{{count}} crew",
      "crewCount_other": "{{count}} crew",
      "equipmentCount_one": "{{count}} equipment",
      "equipmentCount_other": "{{count}} equipment"
    },
    "seriesCalendar": {
      "current": "This day",
      "scheduled": "Scheduled",
      "draft": "Draft",
      "overdue": "Incomplete",
      "completed": "Completed",
      "added": "New"
    },
    "route": "Schedule route",
    "conflicts": "Schedule conflict",
    "crew": {
      "title": "Crew ({{count}})",
      "add": "Add crew member",
      "selectPlaceholder": "Select crew member",
      "searchPlaceholder": "Search by First or Last Name",
      "updateHint": "Crew updates as you select",
      "tooltip": {
        "conflict": {
          "title": "Currently scheduled:",
          "description": "At this time {{name}} has:"
        },
        "replace": "Replace",
        "remove": "Remove",
        "currentSchedule": "Current schedule",
        "completed": "This task won't be updated — it's completed",
        "differentCrew": "This task won't be updated — it has a different crew assigned",
        "differentForeman": "This task won't be updated — it has a different foreman assigned",
        "differentCrewAndForeman": "This task won't be updated — it has a different crew and foreman assigned",
        "disabled": "This task won't be updated",
        "manuallyAdded": "Manually added"
      }
    },
    "equipment": {
      "title": "Equipment ({{count}})",
      "add": "Add equipment",
      "selectPlaceholder": "Select equipment",
      "searchPlaceholder": "Search by name or ID",
      "updateHint": "Equipment updates as you select",
      "tooltip": {
        "conflict": {
          "title": "Currently scheduled:",
          "description": "At this time {{name}} has:"
        },
        "replace": "Replace",
        "remove": "Remove",
        "currentSchedule": "Current schedule",
        "completed": "This task won't be updated — it's completed",
        "differentEquipment": "This task won't be updated — it has a different equipment assigned",
        "differentForeman": "This task won't be updated — it has a different foreman assigned",
        "differentEquipmentAndForeman": "This task won't be updated — it has a different equipment and foreman assigned",
        "disabled": "This task won't be updated",
        "manuallyAdded": "Manually added"
      }
    },
    "confirm": {
      "crewAssignment": {
        "title": "Confirm crew assignment",
        "keep": "Keep current crew",
        "refresh": "Use {{fieldUser}}'s default crew",
        "empty": "No crew members"
      },
      "equipmentAssignment": {
        "title": "Confirm equipment assignment",
        "keep": "Keep current equipment",
        "refresh": "Use {{fieldUser}}'s default equipment",
        "empty": "No equipment"
      },
      "crewChanged": {
        "title": "Default crew changed",
        "message": "Default crew for {{fieldUser}} has changed. Refresh crew for this task?",
        "keep": "Keep current crew",
        "refresh": "Use {{fieldUser}}'s default crew",
        "empty": "No crew members"
      },
      "equipmentChanged": {
        "title": "Default equipment changed",
        "message": "Default equipment for {{fieldUser}} has changed. Refresh equipment for this task?",
        "keep": "Keep current equipment",
        "refresh": "Use {{fieldUser}}'s default equipment",
        "empty": "No equipment"
      }
    },
    "changes": {
      "title": "Apply resource changes to:",
      "message": "Updates resources for the selected days of this task",
      "options": {
        "currentOnly": "This day only",
        "currentAndFuture": "This day and following days",
        "all": "All days of this task"
      },
      "dates": {
        "currentOnly": "Only {{date}}",
        "currentAndFuture_one": "{{date}} and after ({{count}} day)",
        "currentAndFuture_other": "{{date}} and after ({{count}} days)",
        "all_one": "All {{count}} day",
        "all_other": "All {{count}} days"
      }
    },
    "days": {
      "weeks": "Weeks:",
      "weekOf": "{{week}} / {{total}}",
      "previousWeek": "Previous week",
      "nextWeek": "Next week",
      "customCrew": "Custom crew",
      "thisDay": "This day",
      "newDay": "New",
      "notAffected": "Not affected: {{reason}}",
      "reasons": {
        "completed": "already completed",
        "differentCrew": "different crew",
        "differentForeman": "different foreman",
        "differentCrewAndForeman": "different crew and foreman",
        "notSelected": "not in selected days",
        "earlierDay": "earlier day"
      }
    }
  },
  "relatedSchedules": {
    "title": "Bulk reschedule",
    "suggested": "Suggested schedule: ",
    "tooltip": {
      "suggested": "Setup suggested date",
      "remove": "It will be removed from calendar, and cancellation notices will be sent to involved contacts. It will be necessary to schedule it later from scratch."
    }
  },
  "request": {
    "rejected": "reject",
    "approved": "accept",
    "title": "{{status}} request",
    "message": "You are going to {{status}} a task request for the following task:"
  },
  "actions": {
    "add": "Add",
    "addStages": "Add stages",
    "addResource": "Add new resource",
    "save": "Save",
    "createJob": "Create job",
    "send": "Send",
    "sendSchedule": "Send schedule",
    "saveAsDraft": "Save as draft",
    "saveDraft": "Save draft",
    "cancel": "Cancel",
    "delete": "Delete",
    "remove": "Remove",
    "removeSchedule": "Remove schedule",
    "removeTask": "Remove task",
    "archive": "Archive",
    "unarchive": "Unarchive",
    "schedule": "Schedule",
    "reschedule": "Reschedule",
    "form": "Display the form",
    "hide": "Hide",
    "show": "Show",
    "markAsDone": "Mark as done",
    "accept": "Accept",
    "reject": "Reject",
    "details": "Add details",
    "back": "Back",
    "markAllAsRead": "Mark all as read",
    "clear": "Clear",
    "clearAll": "Clear all",
    "edit": "Edit",
    "viewDetails": "View details",
    "done": "Done",
    "uploadFile": "Upload file",
    "confirm": "Confirm",
    "openMap": "Open map",
    "addNote": "Add note",
    "addComment": "Add comment",
    "addFile": "Add file",
    "close": "Close",
    "revert": "Revert",
    "saveChanges": "Save changes",
    "update": "Update",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "reactivate": "Reactivate",
    "workflow": "Update workflow",
    "addWorkflow": "Add workflow",
    "addStage": "Add stage",
    "addTask": "Add task",
    "addSubtask": "Add subtask",
    "editForm": "Edit form",
    "addNewRule": "Add new rule",
    "addNewProperty": "Add new property",
    "export": "Export CSV",
    "exit": "Exit",
    "continue": "Continue",
    "backToToday": "Back to today",
    "submit": "Submit",
    "snapshot": "Take snapshot",
    "takeSnapshots": "Take snapshots",
    "restoreSnapshot": "Restore snapshot",
    "restoreSnapshots": "Restore snapshots",
    "updated": "Updated",
    "duplicate": "Duplicate",
    "copy": "Copy",
    "approve": "Approve",
    "previewWorkflow": "Preview workflow",
    "preview": "Preview",
    "discard": "Discard",
    "publish": "Publish",
    "switch": "Discard & Switch",
    "unschedule": "unschedule",
    "create": "Create",
    "scheduleAnyway": "Schedule anyway",
    "display": "Display",
    "filters": "Filters",
    "filtersWithCount": "Filters ({{count}})",
    "sendSchedules": "Send schedules",
    "addNew": "Add new",
    "views": "Views",
    "tryAgain": "Try again"
  },
  "task": {
    "optional": "optional",
    "type": {
      "standard_task": "Standard task",
      "concrete_order": "Concrete order",
      "material_order": "Material order",
      "material_measurement": "Material measurement",
      "final_yards": "Final yards",
      "form": "Form"
    },
    "confirmation": {
      "subtasks": "Subtasks",
      "external": "External",
      "manual": "Manual",
      "file": "File upload",
      "dependent": "Dependent: {{name}}",
      "route_point_update": "Route point update",
      "form": "Form",
      "extra_attributes_update": "Extra attributes update"
    },
    "scheduleType": {
      "internal": "Internal schedule: {{specialty}}",
      "external": "External",
      "dependent": "Dependent: {{name}}"
    }
  },
  "schedules": {
    "routeLocked": "Can’t reschedule route points - use route tool",
    "contacts": {
      "job": "Workflow contacts",
      "project": "Job contacts",
      "external": "External contacts"
    },
    "additionalContacts": "Additional contacts to be notified",
    "confirmedTooltip": "When checked, the task scheduling will be immediately confirmed.",
    "assigneeTooltip": "Assignee will be notified about this schedule, without option to confirm themselves",
    "revertTooltip": "Click to revert",
    "allDivisions": "Show all users",
    "markAsConfirmed": "Mark as confirmed",
    "saveAsDraftTooltip": "*Saving draft does not notify field users.",
    "completedTooltip": "This task has been marked as completed. Revert by clicking \"Done\" if you want to make any changes.",
    "removeTitle": "Remove schedule",
    "removeInfo": "This action cannot be undone. This will permanently delete this schedule.",
    "mainContact": "Main contact is missing.",
    "addMainContact": "Add the main contact in job details tab to continue.",
    "cancellationConfirmation": "Waiting for confirmation of the cancellation:",
    "yesterday": "Yesterday",
    "today": "Today",
    "tomorrow": "Tomorrow",
    "past": "Past",
    "current": "Today",
    "future": "Future",
    "scheduledAt": "{{stage}} {{action}} {{date}} at {{time}}",
    "unsavedMaterialChanges": "You have unsaved material changes. Save them or cancel before marking this task as done.",
    "noPhoneNumber": "Contact missing phone number. No messages will be sent. Manual confirmation required.",
    "noSchedules": "No schedules found"
  },
  "fileUpload": {
    "title": "Upload file",
    "dragAndDrop": "Drag & Drop files here",
    "drop": "Release to upload file",
    "or": "or",
    "chooseFiles": "Choose files for upload",
    "browseFiles": "Browse files",
    "chooseFilesOrTakePhotos": "Choose files or take photos/video",
    "browseFilesOrTakePhotos": "Upload or take photos",
    "selectFile": "Select file",
    "selectedFiles": "Selected files",
    "maxLength": "Max size: {{maxLength}} MB",
    "queue": {
      "uploading": "Uploading… {{progress}}%",
      "success": "Upload complete",
      "error": "Upload failed"
    }
  },
  "import": {
    "format": "Supported format: .csv",
    "size": "Maximum size: 25 MB",
    "template": {
      "title": "Need a template?",
      "description": "Download a sample template to ensure your data is properly formatted.",
      "action": "Download template"
    },
    "file": {
      "error": "Fail",
      "success": "Done",
      "pending": "Cancel"
    },
    "summary": {
      "title": "Import summary",
      "success_one": "Imported {{count}} user.",
      "success_other": "Imported {{count}} users.",
      "warning_one": "Duplicated {{count}} user:",
      "warning_other": "Duplicated {{count}} users:",
      "error_one": "Error while creating {{count}} user:",
      "error_other": "Error while creating {{count}} users:"
    }
  },
  "deleteDialog": {
    "title": "Delete {{item}} {{name}}",
    "description": "Are you sure you want to permanently remove this {{item}}?",
    "warning": "You can't undo this.",
    "item": {
      "user": "user",
      "note": "note",
      "comment": "comment",
      "file": "file",
      "route": "route",
      "point": "point",
      "points": "points",
      "materialTemplate": "material template"
    }
  },
  "confirmDialog": {
    "title": "Are you sure?"
  },
  "saveChanges": {
    "title": "Save your dashboard work?",
    "description": "It looks like you've made changes to your data table that haven't been saved yet. Proceeding will permanently lose all modifications made during this session."
  },
  "revertDialog": {
    "description": "Are you sure you want to undo the task? All files and values will be removed."
  },
  "overlappingSchedules": {
    "title": "Overlapping schedules",
    "description": "The schedule overlaps with another. Are you sure you want to continue?"
  },
  "publisher": {
    "customTitle_one": "Send {{name}} schedule to {{count}} User",
    "customTitle_other": "Send {{name}} schedule to {{count}} Users",
    "description": {
      "first": "Notification will be sent to users upon publishing.",
      "second": "*Users will automatically be notified on any updates made to a schedule after its been published."
    },
    "confirmationDescription": {
      "first": "*Users will now automatically be notified on any updates made to a schedule now its been published."
    },
    "conflicts": {
      "title": "Schedules conflicts overview",
      "description": "Review each crew member's conflicting jobs below. For each conflict, you can: reschedule one of the jobs to a different time or assign a different crew member. Click on any job to view full details and make changes.",
      "summary": "Showing:",
      "warning_one": "{{count}} schedule conflict",
      "warning_other": "{{count}} schedule conflicts"
    },
    "notification": {
      "title": "Send schedule notifications",
      "confirmationTitle": "Sent schedule notifications",
      "fieldUser_one": "{{count}} field user (Push)",
      "fieldUser_other": "{{count}} field users (Push)",
      "crewWithoutPhone": "{{count}} skipped (no phone number)",
      "crewWithPhone_zero": "{{count}} crew member (Text message)",
      "crewWithPhone_one": "{{count}} crew member (Text message)",
      "crewWithPhone_other": "{{count}} crew members (Text message)"
    },
    "master": {
      "title": "Send schedules to field users",
      "date": "Select date",
      "alert": "No scheduled tasks match in this date range of your current filtered calendar view. Change the dates above, or update your calendar view to include tasks you can publish.",
      "to": "to",
      "noOfDays": "# of days",
      "foremen": {
        "label": "Select field users",
        "tooltip": "Available users are based on filtered view, and awaiting schedules."
      }
    },
    "date": {
      "confirmationTitle_one": "Sent {{date}} schedule to {{count}} User",
      "confirmationTitle_other": "Sent {{date}} schedule to {{count}} Users",
      "title_one": "Send {{date}} schedule to {{count}} User",
      "title_other": "Send {{date}} schedule to {{count}} Users"
    }
  },
  "specialtyOverride": {
    "title": "Missing specialization",
    "description": "This person is does not have the specialization required for this task. Are you sure you want to schedule them?"
  },
  "concreteUpdate": {
    "title": "Update {{name}}",
    "quantity": "Quantity",
    "slump": "Slump"
  },
  "notifications": {
    "taskAlertRaised": "Schedule alert raised",
    "scheduleRequested": "Request is awaiting",
    "scheduleCreated": "New schedule has been created",
    "rescheduleRequested": "Reschedule is awaiting",
    "rescheduleCreated": "New reschedule has been created",
    "scheduleCancelled": "Schedule has been cancelled",
    "taskCompleted": "All plans added in {{jobTitle}} job! Please add necessary CAD files",
    "taskIssueResolved": "Your job issue at {{jobTitle}} has been resolved",
    "taskIssueRaised": "{{name}} reported {{taskName}} job issue at {{jobTitle}}",
    "taskIssueCriticalRaised": "Critical {{taskName}} job issue reported by {{name}} at {{jobTitle}}",
    "taskIssueRemoved": "{{name}} has removed their {{taskName}} job issue at {{jobTitle}}",
    "taskMaterialsChanged": "Final yards have been updated at {{jobTitle}}",
    "questionAnswerGiven": "{{name}} has given answer in questionary",
    "questionAnswerUpdated": "{{name}} has changed answer in questionary",
    "webpushNotificationFailed": "An error with push notifications occurred",
    "textMessageNotificationFailed": "Text message notification not send",
    "crewScheduleNotificationFailed": "Text message notification to crew failed to send"
  },
  "notificationsDialog": {
    "title": "Notifications"
  },
  "paginationItemsLabel": "Showing <1>{{current}}</1> of <2>{{total}}</2>",
  "primaryRole": {
    "crewMember": "Crew",
    "fieldUser": "Field user"
  },
  "role": {
    "administrator": "Administrator",
    "estimator": "Estimator",
    "projectCoordinator": "Project Coordinator",
    "cadTechnician": "CAD/Draftsman",
    "superintendent": "Project Manager",
    "builderSuperintendent": "Builder's Contact",
    "operationsManager": "Operations Manager",
    "inventoryLogistics": "Inventory logistics",
    "billing": "Billing",
    "readOnly": "Read only",
    "foreman": "Foreman",
    "operator": "Operator",
    "subcontractor": "Subcontractor",
    "crewLead": "Crew Lead",
    "finisher": "Finisher",
    "skilledLaborer": "Skilled Laborer",
    "laborer": "Laborer",
    "layoutManager": "Layout Manager",
    "customerServiceManager": "Customer Service Manager",
    "generalSuperintendent": "General Project Manager",
    "driver": "Driver",
    "layoutTechnician": "Layout Technician",
    "crewMember": "Crew Member"
  },
  "table": {
    "name": "Name",
    "firstName": "First name",
    "lastName": "Last name",
    "tenantName": "Tenant name",
    "company": "Company",
    "position": "Position",
    "role": "Role",
    "roles": "Roles",
    "crewMembers": "Crew",
    "assetMembers": "Equipment",
    "fieldUser": "Default foreman",
    "specialization": "Specialization",
    "specializations": "Specializations",
    "email": "Email",
    "phone": "Phone",
    "contact": "Contact",
    "status": "Status",
    "divisions": "Divisions",
    "assignment": "Assignment",
    "assignments": "Assignments",
    "inventory": "Route assignment",
    "slug": "Slug",
    "createdAt": "Created",
    "updatedAt": "Last edit",
    "internalId": "Internal ID",
    "addedTo": "Added To",
    "type": "type",
    "count": {
      "contacts": "No of contacts",
      "users": "No of users",
      "jobs": "No of jobs",
      "activeJobs": "No of active jobs",
      "workflows": "No of workflows"
    },
    "setting": "Setting",
    "value": "Value"
  },
  "statuses": {
    "active": "active",
    "pending": "pending",
    "deactivated": "deactivated",
    "temporaryDisabled": "temporary disabled"
  },
  "noResults": "No results.",
  "sorting": {
    "select": "Select",
    "placeholder_zero": "Sort",
    "placeholder_one": "Sort ({{count}})",
    "placeholder_other": "Sort ({{count}})",
    "title": "Sort by",
    "subtitle": "Define up to 2 levels to reorder user list",
    "primary": {
      "title": "Primary sort"
    },
    "secondary": {
      "title": "Secondary sort"
    },
    "reset": "Reset",
    "apply": "Apply",
    "options": {
      "order_point": "Specialization (Priority)",
      "speciality": "Specialization (Alphabetical)",
      "first_name": "First name",
      "last_name": "Last name",
      "resource_type": "Resource type"
    }
  },
  "filters": {
    "resources": {
      "placeholder": "Resources",
      "equipment": {
        "label": "Equipment",
        "value": "equipment_member"
      },
      "crew": {
        "label": "Crew members",
        "value": "crew_member"
      },
      "field_user": {
        "label": "Field users",
        "value": "field_user"
      }
    },
    "search": {
      "placeholder": {
        "default": "Search",
        "workload": "Search calendar by job name, address or builder",
        "workloadSidebar": "Search jobs by name, address or builder",
        "map": "Search jobs by name, address or builder",
        "jobs": "Search jobs by name, address or builder",
        "resources": "First name, last name",
        "equipment": "Name or internal ID",
        "builders": "Name or email",
        "companies": "Name or email"
      }
    },
    "builderIds": {
      "placeholder": "All Builders"
    },
    "coordinatorIds": {
      "placeholder": "All Coordinators"
    },
    "superintendentIds": {
      "placeholder": "All Project Managers"
    },
    "statuses": {
      "placeholder": "All statuses",
      "options": {
        "draft": "Draft",
        "pending": "Not confirmed",
        "approved": "Confirmed",
        "rejected": "Rejected",
        "active": "Active",
        "deactivated": "Deactivated",
        "warning": "Has alerts"
      }
    },
    "view": {
      "placeholder": "General view",
      "options": {
        "inventory": "Inventory view"
      }
    },
    "teams": {
      "placeholder": "All teams"
    },
    "foremen": {
      "placeholder": "Select field users"
    },
    "states": {
      "options": {
        "construction": "Construction",
        "preConstruction": "Pre-Construction",
        "billing": "Billing",
        "followUp": "Follow-up",
        "hotSeat": "Hot Seat"
      },
      "placeholder": "All job states"
    },
    "stages": {
      "placeholder": "All stages"
    },
    "divisions": {
      "placeholder": "All divisions"
    },
    "workflowIds": {
      "placeholder": "All workflows"
    },
    "taskTypes": {
      "placeholder": "All task types"
    },
    "panel": {
      "statuses": {
        "placeholder": "All statuses"
      }
    }
  },
  "forms": {
    "jobProject": {
      "jobDetails": {
        "label": "Job details",
        "builder": "Builder",
        "jobName": "Job name",
        "jobDescription": "Job description",
        "identifier": {
          "title": "Job identifier",
          "tooltip": "(minimum one required)",
          "subtitle": "Enter a job name or an address to create the job."
        }
      },
      "workflowDetails": {
        "label": "Workflow details",
        "workflowName": "Workflow name",
        "workflowNameTooltip": {
          "description": "Name this scope of work. This will be the tab name in Job Details.",
          "example": "Example: Scope 1, Building 1, Apron, Pad"
        },
        "division": "Division",
        "workflow": "Workflow template",
        "startDate": "Date",
        "startDateLabel": "Do you have a confirmed start date?",
        "followUpSubtitle": "Tentative start or when to follow-up",
        "dateOptions": {
          "startDate": "Start date",
          "followUp": "Follow-up date",
          "yes": "Yes",
          "no": "Not yet"
        },
        "followUpDate": "Follow-up date",
        "workflowTooltip": "Changes at workflow details only apply to this workflow, not the job or other workflows."
      },
      "additionalDetails": {
        "placeholders": {
          "coordinates": "Paste from Google Maps",
          "subdivision": ""
        },
        "address": "Address",
        "coordinates": "GPS coordinates",
        "permitInfo": "Permit info",
        "workflowPermitInfo": "Workflow permit info",
        "permitTooltip": "Uses the job permit. Add additional if an additional one is needed for this workflow",
        "addAnotherPermit": "Add another permit",
        "focusInfo": "This updates all workflows in this job",
        "locationDetails": {
          "locationDetails": "Subdivision or site",
          "subdivision": "Subdivision or site"
        },
        "workflowTooltip": "This data is sourced from the job. Any changes will only affect the workflow level.",
        "mainTooltip": "Any changes will be populated to all workflows.",
        "create": {
          "jobWithProject": {
            "label": "Additional details",
            "permitInfo": "Permit Info"
          },
          "project": {
            "label": "Additional details",
            "permitInfo": "Permit Info"
          },
          "workflow": {
            "label": "Additional workflow details",
            "permitInfo": "Workflow permit Info"
          }
        },
        "edit": {
          "project": {
            "label": "Additional details",
            "permitInfo": "Permit Info"
          },
          "workflow": {
            "label": "Additional Workflow details",
            "permitInfo": "Workflow permit Info"
          }
        },
        "permit": "Permit info",
        "subdivision": "Subdivision or site",
        "builderContact": "Builder's Contact",
        "projectManager": "Project Manager",
        "projectCoordinator": "Project Coordinator"
      }
    },
    "required": "required field",
    "default": {
      "select": {
        "placeholder": "Select",
        "noDivisionPlaceholder": "Select division first",
        "required": "Option must be selected",
        "invalid": "Invalid option"
      },
      "input": {
        "label": "Value",
        "placeholder": "Input",
        "required": "Field must be set"
      },
      "multiSelect": {
        "createNew": "+ create new",
        "clear": "Clear",
        "selectAll": "Select all",
        "search": "Search option...",
        "select": "Select option",
        "empty": "No options"
      },
      "date": {
        "rollingWindows": {
          "title": "Rolling windows",
          "tooltip": "Saved preset will auto-update daily to always show the most recent time frame."
        },
        "completePeriods": {
          "title": "Complete periods",
          "tooltip": "Saved presets will auto-update to always show the latest complete week or month."
        },
        "options": {
          "today": "Today",
          "sinceToday": "Since Today",
          "next30Days": "Next 30 Days",
          "next7Days": "Next 7 Days",
          "nextMonth": "Next Month",
          "nextWeek": "Next Week",
          "thisMonth": "This Month",
          "thisWeek": "This Week",
          "lastWeek": "Last Week",
          "lastMonth": "Last Month",
          "last7Days": "Last 7 Days",
          "last30Days": "Last 30 Days"
        }
      }
    },
    "totalAmount": {
      "required": "Value must be set"
    },
    "firstName": {
      "label": "First Name",
      "required": "First Name must be set"
    },
    "lastName": {
      "label": "Last Name",
      "required": "Last Name must be set"
    },
    "position": {
      "label": "Position",
      "required": "Position must be selected"
    },
    "specialization": {
      "label": "Specialization",
      "required": "Specialization must be selected"
    },
    "email": {
      "label": "Email",
      "placeholder": "Enter email",
      "incorrect": "Invalid email address",
      "format": "Invalid email address",
      "required": "Email address must be set"
    },
    "phoneNumber": {
      "label": "Phone",
      "placeholder": "Enter phone",
      "incorrect": "Invalid phone number",
      "required": "Phone number must be set"
    },
    "companyName": {
      "label": "Builder's company name",
      "required": "Company name must be set"
    },
    "companyEmail": {
      "label": "Company email",
      "required": "Invalid email address"
    },
    "inventory": {
      "label": "This specialty will handle inventory pickups and drop offs "
    },
    "jobName": {
      "label": "Job name"
    },
    "jobType": {
      "label": "Job type",
      "required": "Job Type must be selected"
    },
    "workflow": {
      "label": "Workflow template",
      "required": "Workflow must be selected"
    },
    "tenant": {
      "label": "Select tenant account",
      "required": "Tenant Account must be selected"
    },
    "createMissingElements": {
      "label": "Create all missing elements in Tenant's Account"
    },
    "builder": {
      "label": "Builder",
      "required": "Builder must be selected"
    },
    "coordinator": {
      "label": "Project coordinator",
      "required": "Project Coordinator must be selected"
    },
    "superintendent": {
      "label": "Project manager",
      "required": "Project Manager must be selected"
    },
    "builderSuperintendent": {
      "label": "Builder's contact",
      "required": "Builder's Contact must be selected"
    },
    "subdivision": {
      "label": "Subdivision or site"
    },
    "materialsTag": {
      "label": "Name"
    },
    "division": {
      "label": "Division",
      "required": "Division must be selected"
    },
    "divisions": {
      "label": "Divisions",
      "required": "Divisions must be selected"
    },
    "address": {
      "label": "Address",
      "required": "Address must be set"
    },
    "jobAddress": {
      "label": "Job address",
      "required": "Job address must be set"
    },
    "jobIdentifier": {
      "label": "Job Identifier",
      "required": "Job Name or an Address is required",
      "tooltip": "(minimum one required)",
      "subtitle": "Enter a job name or an address to create the job."
    },
    "geolocalization": {
      "label": "GPS coordinates",
      "incorrect": "Invalid coordinates"
    },
    "startDate": {
      "label": "Start date",
      "required": "One of dates must be set"
    },
    "followUpDate": {
      "label": "Follow-up date",
      "tooltip": "Use this date if there is no project start date yet, or it has become obsolete. Remove the current start date if you want to use a \"follow-up date\"",
      "required": "One of dates must be set"
    },
    "currentPassword": {
      "label": "Old password",
      "required": "Old password must be set"
    },
    "password": {
      "label": "Password",
      "incorrect": "Password is not strong enough",
      "required": "Password must be set"
    },
    "passwordConfirmation": {
      "label": "Repeat password",
      "required": "Must be the same as password"
    },
    "specialty": {
      "label": "Specialty name",
      "placeholder": "Enter specialty name",
      "required": "Specialty name must be set"
    },
    "name": {
      "label": "Name",
      "placeholder": "Enter name",
      "required": "Name must be set"
    },
    "columnName": {
      "label": "Column name"
    },
    "attribute": {
      "label": "Attribute"
    },
    "customName": {
      "label": "Custom name",
      "placeholder": "Enter custom name",
      "required": "Custom name must be set"
    },
    "role": {
      "label": "Role",
      "required": "Role must be set"
    },
    "roles": {
      "label": "Roles",
      "required": "At least one role must be selected",
      "cadTechnicianWarning": "* CAD/Draftsman cannot access Hot Seat or Workload Calendar."
    },
    "crewMembers": {
      "label": "Crew members",
      "scheduledTasksWarning": "*Changes to default crew will not affect already scheduled tasks."
    },
    "assetMembers": {
      "label": "Equipment",
      "scheduledTasksWarning": "*Changes to default equipment will not affect already scheduled tasks."
    },
    "equipment": {
      "scheduledTasksWarning": "*Changes to default field user will not affect already scheduled tasks."
    },
    "status": {
      "label": "Status",
      "options": {
        "active": "Active",
        "temporaryDisabled": "Temporary disabled"
      }
    },
    "fieldUser": {
      "label": "Default field user",
      "scheduledTasksWarning": "*Changes to default field user will not affect already scheduled tasks."
    },
    "task": {
      "label": "Contact group",
      "required": "Contact group must be selected"
    },
    "contact": {
      "label": "Contact",
      "required": "Contact must be selected"
    },
    "main": {
      "label": "Set As main contact"
    },
    "date": {
      "label": "Date",
      "required": "Date must be set"
    },
    "time": {
      "label": "Time",
      "required": "Time must be set"
    },
    "startTime": {
      "label": "Start"
    },
    "endTime": {
      "label": "End"
    },
    "estimatedUnits": {
      "label": "{{name}} estimated {{unit}}"
    },
    "finalUnits": {
      "label": "{{name}} final {{unit}}"
    },
    "note": {
      "label": "Note",
      "required": "Note must be set",
      "placeholder": "type note"
    },
    "comment": {
      "label": "Comment",
      "required": "Comment must be set",
      "placeholder": "type comment"
    },
    "extraComment": {
      "label": "Additional text message",
      "tooltip": "Will be sent with schedule details"
    },
    "important": {
      "label": "mark as important"
    },
    "confirmed": {
      "label": "Mark schedule as confirmed"
    },
    "documentType": {
      "label": "Document type",
      "required": "Document type must be set"
    },
    "documentName": {
      "label": "Document name",
      "required": "Document name must be set"
    },
    "product": {
      "label": "Product",
      "required": "Product must be set"
    },
    "optionName": {
      "label": "Name",
      "required": "Name must be set"
    },
    "includeEstimated": {
      "label": "Include estimated/final values"
    },
    "propertyRequired": {
      "label": "Property is required"
    },
    "valueType": {
      "label": "Value type",
      "required": "Value type is required"
    },
    "quantity": {
      "label": "Quantity",
      "required": "Quantity must be set",
      "placeholder": "0"
    },
    "slump": {
      "label": "Slump",
      "required": "Slump must be set",
      "placeholder": "0"
    },
    "unit": {
      "label": "Unit",
      "required": "Unit must be set"
    },
    "unitName": {
      "label": "Unit name",
      "placeholder": "type name"
    },
    "estimated": {
      "label": "Estimated",
      "labelWithName": "{{name}} estimated:",
      "required": {
        "text": "Estimated value must be set",
        "number": "Estimated value must be a positive number"
      }
    },
    "psi": {
      "label": "PSI",
      "required": "PSI value must be a positive number"
    },
    "final": {
      "label": "Final",
      "labelWithName": "{{name}} final:",
      "fieldLabelWithName": "Final {{name}}:",
      "required": {
        "text": "Final value must be set",
        "number": "Final value must be a positive number"
      }
    },
    "repeatFinal": {
      "label": "Repeat final",
      "fieldLabelWithName": "Confirm final {{name}}:",
      "required": "Must be the same as final"
    },
    "critical": {
      "label": "Blocker (select if job issue stops you from completing work)"
    },
    "company": {
      "label": "Company",
      "required": "Company must be set"
    },
    "category": {
      "label": "Category"
    },
    "externalSiteId": {
      "label": "Job site",
      "required": "Job site must be set"
    },
    "itemExternalId": {
      "label": "Mix type",
      "required": "Mix Type must be set"
    },
    "additive": {
      "label": "Additive (optional)"
    },
    "exact": {
      "label": "Exact"
    },
    "estimatedSlump": {
      "label": "Estimated slump"
    },
    "pourMethod": {
      "label": "Pouring mode",
      "required": "Pouring Mode must be set"
    },
    "pourElement": {
      "label": "Elements to pour",
      "required": "Elements to pour must be set"
    },
    "rateType": {
      "label": "Delivery rate",
      "SPACING_IN_MINUTES": "mins",
      "QTY_PER_HOUR": "hours"
    },
    "additionalInfo": {
      "label": "Additional information for the supplier"
    },
    "internalNote": {
      "label": "Internal note"
    },
    "tenantName": {
      "label": "Tenant displayed name",
      "required": "Tenant displayed name must be set"
    },
    "slug": {
      "label": "Tenant slug",
      "required": "Tenant slug must be set",
      "incorrect": "Invalid slug. Use only a-z (lowercase), 0-9, _ , and -"
    },
    "zone": {
      "label": "Time zone",
      "required": "Time zone must be set"
    },
    "street": {
      "label": "Street"
    },
    "zipCode": {
      "label": "Zip Code"
    },
    "city": {
      "label": "City"
    },
    "state": {
      "label": "State"
    },
    "users": {
      "label": "Users"
    },
    "concreteDirect": {
      "label": "Concrete direct"
    },
    "material": {
      "label": "Related material",
      "required": "Material must be selected"
    },
    "cdUser": {
      "label": "Concrete direct user",
      "required": "Concrete direct user must be set"
    },
    "credentials": {
      "label": "Credentials",
      "required": "Credentials must be set"
    },
    "clientId": {
      "label": "Client ID",
      "required": "Client ID must be set"
    },
    "clientSecret": {
      "label": "Client secret",
      "required": "Client secret must be set"
    },
    "shortcut": {
      "label": "Short name",
      "required": "Short name must be set",
      "placeholder": "Enter short name"
    },
    "type": {
      "label": "Type",
      "required": "Type must be set"
    },
    "identifier": {
      "label": "Identifier",
      "placeholder": "Enter identifier"
    },
    "description": {
      "label": "Description",
      "placeholder": "Enter description"
    },
    "scheduleType": {
      "label": "Schedule type",
      "required": "Schedule type must be set"
    },
    "foreman": {
      "label": "Field user",
      "required": "Field user must be set"
    },
    "foremanSpecialty": {
      "label": "Field user type",
      "required": "Field user type must be set",
      "warning": "Autogenerated"
    },
    "internalId": {
      "label": "Internal ID",
      "required": "Internal ID must be set"
    },
    "dateConfirmation": {
      "label": "Date confirmation",
      "required": "Date confirmation must be set"
    },
    "taskConfirmation": {
      "label": "Confirmation type",
      "required": "Task confirmation must be set"
    },
    "subtaskConfirmation": {
      "label": "Subtask type",
      "required": "Subtask confirmation must be set"
    },
    "scheduleDependentTaskId": {
      "label": "Choose schedule dependent Task"
    },
    "optional": {
      "label": "Required for task completion?",
      "required": "Option must be selected"
    },
    "taskNonObligatory": {
      "label": "Required for stage completion?",
      "required": "Option must be selected"
    },
    "manuallyAdded": {
      "label": "Include in workflow by default?",
      "required": "Option must be selected"
    },
    "multiplicable": {
      "label": "Allow adding multiple occurrences"
    },
    "routePickUp": {
      "label": "Use for route pick ups"
    },
    "routeDropOff": {
      "label": "Use for route drop offs"
    },
    "startsConstruction": {
      "label": "Starts construction"
    },
    "routePlannerPriority": {
      "label": "Priority for route planner when scheduled"
    },
    "releasesInventory": {
      "label": "Releases job inventory"
    },
    "billing": {
      "label": "Billing"
    },
    "concurrentSchedules": {
      "label": "Allow overlapping with other schedules"
    },
    "readyToSchedule": {
      "label": "Show ready to schedule status"
    },
    "importantSchedule": {
      "label": "Show scheduled date on all jobs list"
    },
    "taskImportant": {
      "label": "Show on Hot Seat / On Deck"
    },
    "boolean": {
      "yes": "Yes",
      "no": "No"
    },
    "allocationRelationshipType": {
      "label": "Group",
      "required": "Group must be set"
    },
    "confirmationDependentSubtaskId": {
      "label": "Specify overriding subtask",
      "required": "Related subtask must be set"
    },
    "allowedContentTypes": {
      "label": "Expected file type",
      "placeholder": "All types"
    },
    "materials": {
      "label": "Choose related materials",
      "required": "Related materials must be set"
    },
    "allocationRelationshipTaskName": {
      "label": "Choose related task",
      "required": "Related task must be set"
    },
    "nonObligatory": {
      "label": "Show incomplete reminder?",
      "required": "Option must be selected"
    },
    "questionnaire": {
      "label": "Form",
      "required": "Option must be selected",
      "createNew": "Create a new form for this task"
    },
    "conditionType": {
      "required": "Condition type must be set"
    },
    "message": {
      "required": "Message must be set"
    },
    "relatedId": {
      "required": "Related record must be set"
    },
    "expectedStatus": {
      "required": "Expected status must be set"
    },
    "timeCount": {
      "required": "Time count must be set",
      "tooLong": "Time count is too long"
    },
    "timeUnit": {
      "required": "Time unit must be set"
    },
    "timeState": {
      "required": "Time state must be set"
    },
    "referableId": {
      "required": "Referable record must be set"
    },
    "units": {
      "options": {
        "minutes_one": "Minute",
        "minutes_other": "Minutes",
        "hours_one": "Hour",
        "hours_other": "Hours",
        "days_one": "Day",
        "days_other": "Days"
      }
    },
    "states": {
      "options": {
        "before": "Before",
        "after": "After"
      }
    },
    "relativeScheduleOffset": {
      "label": "Relative schedule offset",
      "required": "Relative schedule offset must be set"
    },
    "appearance": {
      "type": {
        "label": "Show as",
        "required": "Show as must be set",
        "options": {
          "frame": "Ribbon (time frame)",
          "point": "Icon (time point)"
        }
      },
      "color": {
        "label": "Color",
        "required": "Color must be set"
      },
      "icon": {
        "label": "Icon",
        "required": "Icon must be set"
      },
      "text": {
        "label": "Text",
        "required": "Text must be set"
      },
      "preview": "Preview",
      "prefix": {
        "enabled": {
          "label": "Show prefix Icon"
        },
        "icon": {
          "label": "Prefix icon",
          "required": "Prefix icon must be set"
        },
        "text": {
          "label": "Prefix text",
          "required": "Prefix text must be set"
        }
      }
    },
    "workloadType": {
      "options": {
        "month": "Month",
        "two-week": "2-Week",
        "week": "Week",
        "day": "Day"
      }
    },
    "timeMode": {
      "options": {
        "custom": "Custom",
        "fullDay": "Full day",
        "default": "Default (7:00 AM - 3:30 PM)"
      }
    },
    "customSettings": {
      "minutes_one": "{{count}} minute",
      "minutes_other": "{{count}} minutes",
      "errors": {
        "required": "Value is required.",
        "number": "Value must be a whole, non-negative number.",
        "ribbonIntervals": "Allowed values are 15 or 30 minutes.",
        "hourRange": "Hour must be between 0 and 23.",
        "hourOrder": "Starting hour must be earlier than ending hour."
      }
    },
    "globalItem": {
      "name": "Name",
      "description": "Description",
      "group": "Group",
      "weightGroup": {
        "label": "Weight group",
        "required": "Weight group is required"
      },
      "weight": "Weight",
      "unloadingTime": "Unloading time",
      "unpackingTime": "Unpacking time",
      "nameOrDescriptionHint": "Fill in a name, a description, or both.",
      "errors": {
        "required": "Required",
        "alreadyCreated": "Group with this name already exists",
        "nonExist": "Selected group no longer exists",
        "notIncluded": "Invalid weight group",
        "greaterOrEqual": "Must be 0 or more",
        "wholeNumber": "Whole number (0 or more) required",
        "cannotBeChanged": "Item is already in use – this value can't be changed anymore",
        "nameOrDescription": "Fill in a name or a description",
        "invalid": "Invalid value"
      }
    },
    "globalItemsGroup": {
      "label": "Group name",
      "required": "Group name is required",
      "errors": {
        "required": "Required",
        "alreadyCreated": "Group with this name already exists",
        "nonExist": "Selected group no longer exists",
        "notIncluded": "Invalid weight group",
        "greaterOrEqual": "Must be 0 or more",
        "wholeNumber": "Whole number (0 or more) required",
        "cannotBeChanged": "Item is already in use – this value can't be changed anymore",
        "nameOrDescription": "Fill in a name or a description",
        "invalid": "Invalid value"
      }
    },
    "addTaskSchedule": {
      "days": {
        "required": "Pick at least one day"
      }
    }
  },
  "tooltip": {
    "workflow": {
      "stage": {
        "name": "Full stage name, shown in Job Details and other detailed views.",
        "shortcut": "Abbreviated stage name, shown on job pills in All Jobs view.",
        "manuallyAdded": "Determines if stage is added automatically to this workflow. If disabled, users can still add it manually via + icon.",
        "routePickUp": "Tasks for route pick ups at a job are created in this stage. Only one stage per workflow can have it; ticking it here removes it from the other stage.",
        "routeDropOff": "Tasks for route drop offs at a job are created in this stage. Only one stage per workflow can have it; ticking it here removes it from the other stage.",
        "startsConstruction": "Once this stage is completed the job counts as construction; before that as pre construction. Only one stage per workflow can have it; ticking it here removes it from the other stage."
      },
      "task": {
        "name": "Task name, visible across the app (for both Office and Field users).",
        "taskType": "Defines task purpose:\nForm - Includes a form to complete.\nMaterial Measurement - Captures and displays a material measurement (e.g. on Hot Seat).\nMaterial Order - Links to a material order (e.g. Concrete), supports order integrations.\nStandard Task - General task with no special behavior.",
        "materialId": "",
        "scheduleType": "How the task is scheduled:\nInternal - Scheduled with start/end times for field users.\nExternal - Single-time schedule, can be with an external contact.\nDependent - Scheduled relative to another task.\nNo Schedule - No schedule applied.",
        "scheduleDependentTaskId": "Select the task this one's schedule is based on.",
        "foremanSpecialty": "Choose which specialty field users can be assigned.",
        "dateConfirmation": "Who confirms the scheduled date:\nInternal - Assigned field user.\nExternal - External contact (via text).\nManual - Office user confirms.\nNo Confirmation - No confirmation needed.",
        "relativeScheduleOffset": "Set how long before/after its related task this one should be scheduled.",
        "taskConfirmation": "How task completion is confirmed:\nDependent - Another task/subtask marks this complete.\nExternal - External contact confirms via text (sent at its scheduled date).\nManual - Office user confirms.\nSubtasks - Completion depends on subtasks.",
        "confirmationDependentSubtaskId": "",
        "nonObligatory": "If enabled, stage is not completed until this task is done.",
        "manuallyAdded": "Determines if task is added automatically to this stage. If disabled, users can still add it manually via + icon.",
        "multiplicable": "If enabled, users can add this task more than once (via + icon).",
        "routePlannerPriority": "When this task has an active (not draft) schedule, its job is listed higher in the route planner (requested locations, remaining load suggestions).",
        "releasesInventory": "When this task is done, the job's inventory is released: the job becomes available for pick up in the route planner, and the workload calendar shows its inventory as completed.",
        "billing": "Job appears under the Billing filter once this task is completed. Only one task per workflow — selecting it here removes it from the previous one.",
        "concurrentSchedules": "",
        "readyToSchedule": {
          "enabled": "Enables a “ready to schedule” state for this task.",
          "rules": ""
        },
        "importantSchedule": "Displays task date in All Jobs list (affects job ordering).",
        "important": "Shows this task on Hot Seat / On Deck views.",
        "color": "Select color used to represent this task on workload views.",
        "type": "",
        "icon": "Select icon which will be used to repesent this task on Hot Seat / On Deck.",
        "text": "Select text (up to 2 letters) to be displayed instead of the icon.",
        "prefix": {
          "color": "",
          "icon": "Select icon which will be used in it's prefix icon (secondary marker shown before task name).",
          "text": "Select text (up to 2 letters) to be displayed instead of the prefix icon (secondary marker shown before task name)."
        },
        "questionaryId": "Pick a form you already created, or leave \"Create a new form for this task\" to get an empty one you can fill in under Forms."
      },
      "subtask": {
        "name": "Subtask name, visible across the app.",
        "allocationRelationshipType": "For multi-day tasks, decide when subtask applies: every day, first day, last day, or alongside a related task.",
        "allocationRelationshipTaskName": "Select the task that determines this subtask's placement.",
        "taskConfirmation": "How the subtask is confirmed:\nDependent - Another subtask completes this one.\nManual - User marks complete.\nMaterials Update - Requires material entry.\nUploaded File - Requires file upload.",
        "confirmationDependentSubtaskId": "Choose a subtask that, once completed, will close this one.",
        "materials": "Assign which material(s) this subtask tracks.",
        "optional": "If enabled, completing this subtask is required to finish its parent task (if confirmation type = subtasks).",
        "nonObligatory": "Sends reminders for missing uploads/files."
      },
      "material": {
        "product": "Material's display name.",
        "property": {
          "name": "Attribute of the material (e.g. weight).",
          "valueType": "How values are entered (Number or Text).",
          "unit": "Unit for the property (e.g. pounds).",
          "required": "If enabled, this field must be filled.",
          "includeEstimated": "Allow both estimated and final values (or final only).",
          "doubleEntryRequired": "Require double entry for given property value",
          "showOnHotSeat": "Show this property value in the Hot Seat view for quick access during active work. You can choose only one property per material.",
          "fieldUpdate": "Require this property to be updated by Field user"
        }
      },
      "form": {
        "section": "",
        "question": "",
        "answer": "Define correct answers for this question. If set, the form is only complete when all questions with expected answers match.\nQuestions without expected answers are optional and won't block form completion.",
        "notificationRules": "Set who gets notified when a specific answer is given."
      }
    }
  },
  "messages": {
    "copy": "Text has been copied.",
    "success": {
      "resource": {
        "user": {
          "create": "User created successfully!",
          "resend": "User invitation resent.",
          "deactivate": "User deactivated successfully!",
          "restore": "User restored successfully!",
          "update": "User updated successfully!",
          "authorizationFailed": "Authorization failed. You are not allowed to remove this user."
        },
        "equipment": {
          "create": "Equipment created successfully!",
          "update": "Equipment updated successfully!",
          "restore": "Equipment restored successfully!",
          "remove": "Equipment removed successfully!",
          "deactivate": "Equipment deactivated successfully!",
          "authorizationFailed": "Authorization failed. You are not allowed to remove this equipment."
        }
      },
      "builder": {
        "create": "Builder created successfully!",
        "update": "Builder updated successfully!",
        "remove": "Builder removed successfully!"
      },
      "company": {
        "create": "Company created successfully!",
        "update": "Company updated successfully!",
        "remove": "Company removed successfully!"
      },
      "admin": {
        "create": "Admin created successfully!",
        "update": "Admin updated successfully!",
        "remove": "Admin removed successfully!",
        "resend": "Admin invitation resent."
      },
      "tenant": {
        "create": "Tenant created successfully!",
        "update": "Tenant updated successfully!",
        "remove": "Tenant removed successfully!",
        "deactivate": "Tenant deactivated successfully!",
        "reactivate": "Tenant reactivated successfully!",
        "takeSnapshots": "Jobs snapshots created successfully",
        "restoreSnapshots": "Jobs snapshots restored successfully",
        "integration": {
          "create": "Tenant integration created successfully!",
          "update": "Tenant integration updated successfully!",
          "remove": "Tenant integration removed successfully!"
        }
      },
      "workflows": {
        "create": "Workflow created successfully!",
        "duplicate": "Workflow duplicated successfully!",
        "update": "Workflow updated successfully!",
        "remove": "Workflow removed successfully!",
        "deactivate": "Workflow deactivated successfully!",
        "activate": "Workflow activated successfully!",
        "copy": "Workflow copied successfully!",
        "questionnaire": {
          "reorder": "Questionnaire item reordered successfully!",
          "section": {
            "create": "Questionnaire section created successfully!",
            "update": "Questionnaire section updated successfully!",
            "remove": "Questionnaire section removed successfully!"
          },
          "question": {
            "create": "Questionnaire question created successfully!",
            "update": "Questionnaire question updated successfully!",
            "remove": "Questionnaire question removed successfully!"
          },
          "notification": {
            "create": "Questionnaire notification created successfully!",
            "update": "Questionnaire notification updated successfully!",
            "remove": "Questionnaire notification removed successfully!"
          },
          "create": "Form created successfully!",
          "remove": "Form removed successfully!"
        },
        "alerts": {
          "create": "Alerts created successfully!",
          "update": "Alerts updated successfully!"
        },
        "revoke": "Workflow revoked successfully!",
        "publish": "Workflow published successfully!",
        "reorder": "Workflow item reordered successfully!",
        "stage": {
          "create": "Stage created successfully!",
          "update": "Stage updated successfully!",
          "remove": "Stage removed successfully!"
        },
        "task": {
          "create": "Task created successfully!",
          "update": "Task updated successfully!",
          "remove": "Task removed successfully!"
        },
        "subtask": {
          "create": "Subtask created successfully!",
          "update": "Subtask updated successfully!",
          "remove": "Subtask removed successfully!"
        }
      },
      "project": {
        "update": "Job details updated successfully!"
      },
      "job": {
        "create": "Job created successfully!",
        "update": "Job details updated successfully!",
        "cancel": "Job cancelled successfully!",
        "complete": "Job archived successfully!",
        "unarchive": "Job unarchived successfully!",
        "snapshot": "Job snapshot created successfully!",
        "restore": "Job snapshot restored successfully!"
      },
      "workflow": {
        "create": "Workflow created successfully!",
        "update": "Workflow details updated successfully!",
        "cancel": "Workflow cancelled successfully!",
        "complete": "Workflow archived successfully!",
        "unarchive": "Workflow unarchived successfully!",
        "snapshot": "Workflow snapshot created successfully!",
        "restore": "Workflow snapshot restored successfully!",
        "reorder": "Workflows reordered successfully!"
      },
      "issue": {
        "create": "Job Issue created successfully!",
        "resolve": "Job Issue resolved successfully!",
        "remove": "Job Issue removed successfully!"
      },
      "contact": {
        "create": "Contact created successfully!",
        "update": "Contact updated successfully!",
        "remove": "Contact removed successfully!",
        "assign": "Contact added from global list successfully!"
      },
      "request": {
        "status": "Request status changed successfully!"
      },
      "schedule": {
        "create": "Task scheduled successfully!",
        "update": "Task rescheduled successfully!",
        "remove": "Task schedule removed successfully!",
        "saveAndSend": "Task schedule sent successfully!",
        "send": "Tasks schedules sent successfully!"
      },
      "subtask": {
        "complete": "Subtask completed successfully!",
        "revert": "Subtask reverted successfully!"
      },
      "task": {
        "complete": "Task completed successfully!",
        "revert": "Task reverted successfully!",
        "create": "Task created successfully!",
        "remove": "Task removed successfully!",
        "scheduled": "Task added and scheduled"
      },
      "note": {
        "create": "Note created successfully!",
        "update": "Note updated successfully!",
        "remove": "Note removed successfully!"
      },
      "notifications": {
        "read": "Notification marked as read successfully!",
        "readAll": "All notifications marked as read successfully!",
        "clearAll": "All notifications cleared successfully!"
      },
      "cancellation": {
        "remove": "Cancellation confirmation removed successfully!"
      },
      "superintendent": {
        "update": "Builder's contact updated successfully!",
        "create": "Builder's contact created successfully!",
        "remove": "Builder's contact removed successfully!"
      },
      "file": {
        "upload": "File uploaded successfully!",
        "update": "File updated successfully!",
        "remove": "File removed successfully!"
      },
      "material": {
        "reorder": "Material reordered successfully!",
        "create": "Material created successfully!",
        "update": "Material updated successfully!",
        "remove": "Material removed successfully!",
        "option": {
          "reorder": "Material option reordered successfully!"
        }
      },
      "jobInventory": {
        "create": "Job inventory item created successfully!",
        "remove": "Job inventory item removed successfully!",
        "update": "Job inventory items updated successfully!",
        "createMany": "Job inventory items created successfully!",
        "removeMany": "Job inventory items removed successfully!"
      },
      "inventory": {
        "pair": {
          "create": "Inventory route delivery created successfully!",
          "remove": "Inventory route delivery removed successfully!"
        },
        "routes": {
          "create": "Inventory route created successfully!",
          "points": {
            "complete": "Route delivery completed successfully!"
          },
          "update": "Inventory route updated successfully!",
          "remove": "Inventory route removed successfully!"
        },
        "quantities": {
          "update": "Inventory quantities updated successfully!"
        },
        "create": "Inventory route delivery created successfully!",
        "update": "Inventory route delivery updated successfully!",
        "remove": "Inventory route delivery removed successfully!",
        "clearAll": "Inventory route deliveries cleared successfully!",
        "reorder": "Inventory route deliveries reordered successfully!"
      },
      "questionary": {
        "answer": {
          "create": "Questionary answer created successfully!",
          "update": "Questionary answer updated successfully!"
        },
        "attachment": {
          "update": "Questionary attachment updated successfully!",
          "remove": "Questionary attachment removed successfully!"
        }
      },
      "preset": {
        "create": "Preset created successfully!",
        "update": "Preset updated successfully!",
        "remove": "Preset removed successfully!"
      },
      "specialties": {
        "create": "Specialty created successfully!",
        "update": "Specialty updated successfully!",
        "deactivate": "Specialty deactivated successfully!",
        "reactivate": "Specialty reactivated successfully!",
        "verify": "Specialty verified successfully!"
      },
      "divisions": {
        "create": "Division created successfully!",
        "update": "Division updated successfully!",
        "remove": "Division removed successfully!"
      },
      "displayOptions": {
        "create": "Display options updated successfully!"
      },
      "materialsTag": {
        "create": "Tag created successfully!",
        "update": "Tag updated successfully!",
        "destroy": "Tag removed successfully!"
      },
      "materialsTemplate": {
        "create": "Template created successfully!",
        "update": "Template updated successfully!",
        "destroy": "Template removed successfully!",
        "discard": "Draft discarded successfully!",
        "activate": "Template activated successfully!",
        "deactivate": "Template deactivated successfully!",
        "duplicate": "Template duplicated successfully!"
      },
      "customSettings": {
        "update": "Setting saved successfully!"
      },
      "globalItems": {
        "create": "Item created successfully!",
        "update": "Item updated successfully!",
        "remove": "Item removed successfully!"
      },
      "globalItemsGroups": {
        "create": "Group created successfully!",
        "update": "Group renamed successfully!",
        "remove": "Group and its items removed successfully!"
      }
    },
    "failure": {
      "tenant": {
        "integration": "Could not integrate with Concrete Direct. Please check credentials."
      },
      "file": {
        "size": "Size of file {{name}} is too large to be uploaded. Please select different file."
      },
      "request": {
        "forbidden": "You don't have access to this. Please contact support.",
        "server": "Something went wrong on our side. Please contact support.",
        "default": "We couldn't load this page. Please contact support.",
        "network": "Connection is slow or unavailable. Check your internet and try again."
      },
      "customSettings": {
        "update": "Setting could not be saved."
      }
    }
  },
  "pages": {
    "users": {
      "removed": "Removed"
    },
    "equipment": {
      "removed": "Removed"
    },
    "notFound": {
      "title": "Page not found",
      "first": "Sorry, the page you were looking for was not found.",
      "second": "It appears to have been removed or is no longer available.",
      "action": "Back to home page"
    },
    "error": {
      "title": "Something went wrong",
      "first": "Please refresh the page and try again.",
      "second": "If issue persists, please share the error code with the development team:",
      "path": "Path:",
      "refresh": "Refresh",
      "back": "Back to home page"
    },
    "login": {
      "title": "Login",
      "action": "Sign in",
      "link": "Forgot password?",
      "sessionExpired": "Your session has expired. Please sign in again.",
      "finalizeError": "We couldn't finish signing you in. Please try again.",
      "accountLoadError": {
        "title": "We couldn't load your account",
        "description": "You're signed in, but your account didn't load. Try again. If it keeps happening, sign in again.",
        "signInAgain": "Sign in again",
        "sessionDescription": "Your sign-in session is incomplete. Sign in again to continue."
      }
    },
    "oauth": {
      "title": "Connect {{client}} to Retti?",
      "description": "{{client}} is asking to read your company's Retti data for you: schedules, people, equipment and materials.",
      "readOnly": "It can only read. It can't create, change or delete anything.",
      "companyOnly": "It only sees your company's data.",
      "signedInAs": "Signed in as {{email}}",
      "redirectNote": "After you choose, you'll go back to {{host}}.",
      "allow": "Allow",
      "deny": "Deny",
      "loginHint": "Sign in to connect your assistant to Retti.",
      "invalidTitle": "This connection request isn't valid",
      "invalidText": "Start connecting again from your assistant.",
      "missingParams": "The link is missing information. Start connecting again from your assistant.",
      "adminTitle": "Use your company account",
      "adminText": "Panel admin accounts can't connect an assistant. Sign out, then sign in with your company account.",
      "accessDisabledTitle": "Your company doesn't have access yet",
      "accessDisabledText": "Connecting AI assistants to Retti isn't turned on for your company. Ask whoever manages Retti at your company to have it enabled.",
      "signOut": "Sign out",
      "genericError": "Something went wrong. Please try again."
    },
    "passwordRecovery": {
      "title": "Reset password",
      "action": "Reset",
      "link": "Back to log in"
    },
    "passwordRecoveryInfo": {
      "title": "Check your email",
      "body": {
        "paragraph1": "If the email address was found in our database, we've sent you an email with a link to reset your password",
        "paragraph2": "If you do not receive it shortly, please consider checking your spam folder. \nAdditionally, ensure that the email address you've provided is accurate"
      }
    },
    "passwordReset": {
      "title": "Set new password",
      "action": "Save",
      "desc": {
        "info": "Make a sure your password contains at least:",
        "point1": "8 characters",
        "point2": "1 capital and 1 small letter",
        "point3": "1 digit",
        "point4": "1 special character"
      }
    },
    "passwordResetConfirmation": {
      "title": "Password successfully changed",
      "paragraph": "Your password has been updated successfully. \nYou can now use your new password to log in",
      "link": "Back to log in"
    },
    "acceptInvitation": {
      "action": "Register"
    },
    "hotSeat": {
      "noTasks": "No tasks found with current filters",
      "24h": "24h"
    },
    "resources": {
      "title": "Resources",
      "create": "Create new resource",
      "update": "Edit {{name}}",
      "item": "resource",
      "type": "Resource type",
      "actionTypes": {
        "title": "Action type",
        "deactivate": "Deactivate",
        "temporary_disabled": "Temporary disabled"
      },
      "deactivate": {
        "title": "Deactivate {{type}} {{name}}",
        "description": "Are you sure you want to deactivate this {{type}}? All historical information tied to this {{type}} will remain.",
        "warning": "Deactivating this resource will remove any existing assignments and associations with jobs.",
        "type": {
          "user": "user",
          "equipment": "equipment"
        },
        "assignment": {
          "crewReplacement": "Crew member replacement",
          "crewReassignment": "Crew reassignment",
          "noReplacement": "No replacement needed",
          "leaveUnassigned": "Leave crew unassigned",
          "equipmentReplacement": "Equipment replacement",
          "equipmentReassignment": "Equipment reassignment",
          "title": {
            "tasks": "Task assignments",
            "crew": "Crew assignments",
            "equipment": "Equipment assignments"
          },
          "equipment": {
            "tasks": {
              "deactivate": {
                "warning": {
                  "title": "Active task assignments",
                  "message": "This equipment is assigned to active task."
                },
                "description": "Deactivating this resource will remove any existing assignments and associations with jobs."
              },
              "temporary_disabled": {
                "warning": {
                  "title": "Active task assignments",
                  "message": "This equipment is assigned to active task."
                },
                "description": "Disabling this resource will not remove any existing assignments and associations with jobs."
              }
            },
            "crew": {
              "deactivate": {
                "warning": {
                  "title": "Default equipment assignment",
                  "message": "{{equipmentName}} is currently in a default crew. It will be removed from {{fieldUserName}}'s equipment."
                },
                "description": ""
              },
              "temporary_disabled": {
                "warning": {
                  "title": "Default equipment assignment",
                  "message": "{{equipmentName}} is currently in a default crew. It will not be removed from {{fieldUserName}}'s equipment."
                },
                "description": ""
              }
            }
          },
          "fieldUser": {
            "tasks": {
              "warning": {
                "title": "Active task assignments",
                "message": "This field user is assigned to scheduled tasks."
              },
              "description": "All scheduled tasks will remain scheduled but unassigned. Tasks will move to Draft status. Crew assignments remain unchanged."
            },
            "crew": {
              "warning": {
                "title": "This field user has a crew",
                "message": "You can reassign the whole crew to someone else or leave them unassigned."
              },
              "description": "Crew reassignment will not apply to the already scheduled tasks."
            },
            "equipment": {
              "warning": {
                "title": "This field user has equipment",
                "message": "You can reassign the whole equipment to someone else or leave them unassigned."
              },
              "description": "Equipment reassignment will not apply to the already scheduled tasks."
            }
          },
          "crewMember": {
            "tasks": {
              "warning": {
                "title": "Active task assignments",
                "message": "This crew member is assigned to active task."
              },
              "description": "This crew member will be removed from all scheduled tasks. Do you want to replace them in these tasks?"
            },
            "crew": {
              "warning": {
                "title": "Default crew assignment",
                "message": "{{crewMemberName}} is currently in a default crew. User will be removed from {{fieldUserName}}'s crew."
              },
              "description": ""
            },
            "equipment": {
              "warning": {
                "title": "Default equipment assignment",
                "message": "{{equipmentName}} is currently in a default equipment. Equipment will be removed from {{fieldUserName}}'s equipment."
              },
              "description": ""
            }
          }
        }
      },
      "tab": {
        "office": "Office",
        "fieldWorkers": "Fieldworkers",
        "equipment": "Equipment"
      },
      "options": {
        "office": "Office",
        "fieldUser": "Field user",
        "crewMember": "Crew member",
        "equipment": "Equipment",
        "assetMembers": "Equipment"
      },
      "basicInfo": "Basic info",
      "workDetails": "Work details",
      "defaultCrew": "Default crew",
      "defaultAsset": "Default equipment"
    },
    "builders": {
      "title": "Builders",
      "create": "Create new builder",
      "update": "Edit builder",
      "item": "builder",
      "countTooltip": "No contacts added",
      "superintendents": {
        "title": "Builder's Contacts",
        "action": "Add new contact",
        "item": "builder contact",
        "dialog": {
          "create": "Create new builder contact",
          "update": "Edit builder contact"
        }
      },
      "data": {
        "name": "builder's company name",
        "phone": "phone number",
        "email": "email"
      },
      "back": "builders list"
    },
    "companies": {
      "title": "External contacts",
      "create": "Create new company",
      "update": "Edit company",
      "item": "company",
      "contacts": {
        "title": "Company contacts",
        "action": "Add new contact",
        "item": "external contact",
        "create": "Create new external contact",
        "update": "Edit external contact",
        "addToGlobal": "Add contact to global list"
      },
      "data": {
        "phone": "phone number",
        "email": "email"
      },
      "back": "companies list"
    },
    "admins": {
      "title": "Admins",
      "item": "admin",
      "dialog": {
        "details": {
          "create": "Create new admin",
          "update": "Edit admin"
        }
      }
    },
    "tenants": {
      "title": "Tenants",
      "tooltip": {
        "noUsers": "No users added",
        "office_one": "{{count}} office user",
        "office_other": "{{count}} office users",
        "foreman_one": "{{count}} field user",
        "foreman_other": "{{count}} field users",
        "crewMember_one": "{{count}} crew member",
        "crewMember_other": "{{count}} crew members"
      },
      "dialog": {
        "reactivate": {
          "title": "Reactivate tenant {{companyName}}",
          "description": "Are you sure you want to reactivate this tenant?"
        },
        "deactivate": {
          "title": "Deactivate tenant {{companyName}}",
          "description": "Are you sure you want to deactivate this tenant?",
          "error": "Deactivating this tenant will immediately revoke all user access to their environment. No emails, notifications, or other automated communications will be sent while the tenant is deactivated.",
          "tooltip": "All tenant data will remain preserved and can be restored by reactivating the tenant."
        },
        "details": {
          "create": "Create new tenant",
          "update": "Edit tenant",
          "address": "Address",
          "invite": "Invite admin users",
          "integrations": "Integrations",
          "addNext": "Add next user"
        },
        "takeSnapshots": {
          "title": "Create snapshots",
          "description": "Create snapshots for all tenant jobs"
        },
        "restoreSnapshots": {
          "title": "Restore snapshots",
          "description": "Restore snapshots for all tenant jobs"
        },
        "integration": {
          "details": {
            "create": "Create new {{name}} integration",
            "update": "Edit {{name}} integration",
            "pending": "{{name}} integration"
          },
          "remove": {
            "title": "Delete {{name}} integration",
            "description": "Are you sure you want to remove this integration?",
            "warning": "This will disable all related functionality until you enable it again."
          }
        }
      },
      "item": "tenant",
      "integrations": {
        "title": "Integrations",
        "item": "integration",
        "service": {
          "title": {
            "concreteDirect": "Concrete direct",
            "twilio": "Twilio"
          }
        }
      },
      "data": {
        "name": "company name",
        "slug": "slug",
        "timeZone": "time zone",
        "phone": "phone number",
        "email": "company email",
        "address": "address"
      },
      "back": {
        "job": "job details",
        "tenants": "tenants list",
        "workflows": "workflows list"
      },
      "navigation": {
        "details": "Details",
        "settings": "Settings",
        "resources": "Resources",
        "workflows": "Workflows",
        "materials": "Materials",
        "dashboards": "Dashboards presets",
        "specialties": "Field specialties",
        "divisions": "Divisions",
        "globalItems": "Inventory"
      }
    },
    "workflows": {
      "title": "Workflows",
      "lastSave": "Last save: {{date}}",
      "lastPublish": "Last publish: {{date}}",
      "jobs_one": "{{count}} active job",
      "jobs_other": "{{count}} active jobs",
      "viewOnlyMode": "View only mode.",
      "flags": {
        "routePickUp": "Route pick up",
        "routeDropOff": "Route drop off",
        "startsConstruction": "Starts construction",
        "routePlannerPriority": "Route planner priority",
        "releasesInventory": "Releases inventory",
        "billing": "Billing"
      },
      "current": {
        "action": "Current",
        "banner": "Last published version. View only mode.",
        "tooltip": "Changes will apply to existing jobs",
        "warning": "Last published version. View only mode."
      },
      "live": {
        "action": "Live edit",
        "banner": "Live edit: Quick changes only. Changes will apply to Existing and New Jobs. Your current Draft will also be synced with published changes.",
        "tooltip": "Changes will apply to existing and new jobs",
        "warning": "Live edit restriction: Some fields can only be modified in Draft Mode."
      },
      "draft": {
        "action": "Draft",
        "banner": "Draft edit: Full editing capabilities. Changes will apply to new jobs only.",
        "tooltip": "Changes will apply to new jobs only",
        "warning": "Draft edit: Full editing capabilities. Changes will apply to new jobs only."
      },
      "publishedVersion": "Published version, based on:",
      "changeSummary": "Change summary",
      "compare": "Compare with last published",
      "changes": {
        "fields": {
          "added": {
            "stage": "Added stage",
            "task": "Added task",
            "subtask": "Added subtask",
            "questionnaire": "Added questionnaire",
            "tasksConditionSetting": "Added task condition setting",
            "subtasksConditionSetting": "Added subtask condition setting",
            "materialOption": "Added material option"
          },
          "name": "Name",
          "shortcut": "Shortcut",
          "important": "Important",
          "importantSchedule": "Important schedule",
          "beginningOfDay": "Beginning of day",
          "message": "Message",
          "minutes": "Minutes",
          "conditionType": "Condition type",
          "appearanceIcon": "Icon",
          "appearanceText": "Text",
          "appearanceColor": "Color",
          "appearanceType": "Type",
          "appearanceIsPrefix": "Show prefix",
          "appearancePrefixIcon": "Prefix icon",
          "appearancePrefixText": "Prefix text",
          "appearancePrefixColor": "Prefix color"
        },
        "info": "added",
        "danger": "removed",
        "warning": "modified"
      },
      "navbar": {
        "materials": "Materials",
        "forms": "Forms",
        "workProgress": "Work progress"
      },
      "status": {
        "draft": "draft",
        "live": "live",
        "active": "active",
        "deactivated": "deactivated"
      },
      "task": {
        "optional": "optional",
        "specialtyWarning": "Specialization was automatically activated or created"
      },
      "alerts": {
        "add": "Alerts",
        "edit": "Edit alerts"
      },
      "form": {
        "add": "Form",
        "edit": "Edit form"
      },
      "dialog": {
        "switchEditMode": {
          "title": "Switch edit mode?",
          "description": "You have unsaved current {{prev}} changes. Switching to {{next}} mode will discard these changes."
        },
        "alerts": {
          "create": "Create alerts",
          "update": "Edit alerts",
          "item": "stage",
          "rule": {
            "title": "Alert rule",
            "show": "Show:",
            "message": "with message:",
            "if": "If:",
            "status": "is not in minimum status:",
            "when": "When:",
            "pushNotificationMessage": "Push notification message"
          }
        },
        "workflow": {
          "revoke": {
            "title": "Revoke workflow {{name}}",
            "description": "Are you sure you want to revoke this workflow?"
          },
          "publish": {
            "title": "Publish workflow {{name}}",
            "description": "Are you sure you want to publish this workflow?"
          },
          "create": "Create new workflow",
          "copy": "Copy workflow to tenant account",
          "save": {
            "title": "Copy workflow {{name}} to library",
            "description": "Are you sure you want to copy this workflow?"
          },
          "issues": {
            "title": "Publishing issues",
            "description": "The workflow contains elements that don't exist in your account. You can create them automatically or review manually.",
            "missing": {
              "divisions": "Missing divisions",
              "specialties": "Missing specializations"
            },
            "actions": {
              "review": "Cancel & Review manually",
              "confirm": "Confirm & Publish"
            }
          },
          "duplicate": "Duplicate workflow {{name}}",
          "update": "Edit workflow",
          "deactivate": {
            "title": "Deactivate workflow {{name}}",
            "description": "Are you sure you want to deactivate this workflow?"
          },
          "activate": {
            "title": "Activate workflow {{name}}",
            "description": "Are you sure you want to activate this workflow?"
          },
          "remove": {
            "title": "Remove workflow {{name}}",
            "description": "Are you sure you want to remove this workflow?"
          },
          "item": "workflow"
        },
        "stage": {
          "create": "Create new stage",
          "update": "Edit stage",
          "item": "stage",
          "routeHint": "A workflow needs both a route pick up and a route drop off stage (they can be the same stage), or neither.",
          "optionalHint": "Route and construction flags cannot be used on a stage that is not included in the workflow by default."
        },
        "task": {
          "create": "Create new task",
          "update": "Edit task",
          "item": "task",
          "heading": {
            "material": "Related material",
            "details": "Schedule details",
            "confirmation": "Task confirmation",
            "settings": "Additional settings"
          },
          "rules": {
            "heading": "Ready To schedule rules",
            "if": "If:",
            "and": "And:",
            "inStatus": "is in minimum status",
            "action": "Add new rule"
          },
          "appearance": {
            "heading": "Interface representation"
          }
        },
        "subtask": {
          "create": "Create new subtask",
          "update": "Edit subtask",
          "item": "subtask"
        }
      },
      "questionnaire": {
        "title": "Edit Form",
        "subtitle": {
          "usedBy": "Used in: {{names}}"
        },
        "answer": {
          "title": "Expected Answer:",
          "option": {
            "yes": "Yes",
            "no": "No",
            "n/a": "N/A",
            "notSet": "Not set"
          },
          "clear": "Clear"
        },
        "remove": {
          "item": {
            "section": "section",
            "question": "question",
            "notification": "notification"
          }
        },
        "notifications": {
          "title": "Notification rules:",
          "setup": "Setup Notification rules",
          "textMessage": "Text message",
          "rule": "If <bold>{{answer}}</bold> notify <bold>{{users}}</bold> via text message"
        },
        "addNewSection": "Add new section",
        "addNewQuestion": "Add new question"
      },
      "questionnaires": {
        "title": "Forms",
        "action": "New form",
        "empty": "No forms yet. Create one here, or add a task with the \"Form\" type.",
        "unnamed": "Untitled form",
        "usedBy": "Used in: {{names}}",
        "notUsed": "Not used yet. You can delete it, and unused forms are also removed when the workflow is published.",
        "needsQuestions": "Needs questions",
        "dialog": {
          "title": "New form",
          "placeholder": "e.g. Footing layout checklist"
        },
        "remove": "Delete form \"{{name}}\" with all its sections and questions? This can't be undone."
      },
      "materials": {
        "value": "Value: {{value}}",
        "units": "Units: {{unit}}",
        "required": "required",
        "cumulative": "cumulative",
        "estimatedAndFinalValues": "estimated and final values",
        "fieldUpdate": "field update",
        "doubleEntryRequired": "x2",
        "dialog": {
          "title": "Add material",
          "product": "Product name",
          "properties": {
            "label": "Property:",
            "name": "Property name",
            "valueType": "Value type",
            "unit": "Unit name",
            "required": "Required",
            "fieldUpdate": "Field update",
            "doubleEntryRequired": "Double entry required",
            "includeEstimated": "Include estimated/final values",
            "add": "Add another property",
            "number": "Number",
            "text": "Text",
            "showOnHotSeat": "Show on hot seat"
          }
        }
      }
    },
    "materials": {
      "navigation": {
        "templates": "Material templates",
        "tags": "Material tags"
      },
      "actions": {
        "showDeactivated": "Show deactivated",
        "add": {
          "template": "Add new material template",
          "tag": "Add new tag"
        }
      },
      "tags": {
        "item": "tag",
        "dialog": {
          "create": "New tag",
          "update": "Edit tag",
          "destroy": {
            "title": "Remove tag {{name}}",
            "description": "Are you sure you want to remove"
          },
          "destroyWithReplacement": {
            "dialogTitle": "Danger confirmation",
            "title": "Remove tag {{name}}",
            "description": "Are you sure you want to remove",
            "assignments": {
              "title": "Tag assignments",
              "warningTitle": "Active tag assignments",
              "warningMessage": "This tag is assigned to materials. Choose a replacement before removing it."
            },
            "reassignMessage": "All materials tagged {{name}} will be reassigned to the replacement tag.",
            "undoWarning": "This action cannot be undone.",
            "replacementLabel": "Replacement tag",
            "replacementPlaceholder": "Search or create A Tag",
            "submit": "Deactivate"
          }
        },
        "table": {
          "lastEdit": "last edit"
        },
        "types": {
          "default": "Default",
          "manual": "Tenant created"
        }
      },
      "templates": {
        "add": "Create material template",
        "edit": "Edit material template",
        "lastSave": "Last save: {{date}}",
        "lastPublish": "Last published: {{date}}",
        "status": {
          "draft": "draft",
          "live": "live",
          "active": "active",
          "deactivated": "deactivated"
        },
        "dialog": {
          "product": "Material name",
          "properties": {
            "label": "Properties",
            "name": "Property name",
            "valueType": "Value type",
            "unit": "Unit name",
            "required": "Required",
            "includeEstimated": "Estimated/final values",
            "add": "Add another property",
            "number": "Number",
            "text": "Text",
            "showOnHotSeat": "Show on Hot Seat",
            "cumulative": "Cumulative"
          },
          "duplicate": {
            "title": "Duplicate material template {{product}}"
          },
          "activate": {
            "title": "Activate template {{product}}",
            "description": "Are you sure you want to activate this template?"
          },
          "deactivate": {
            "title": "Deactivate template {{product}}",
            "description": "Are you sure you want to deactivate this template?"
          },
          "revoke": {
            "title": "Revoke template {{product}}",
            "description": "Are you sure you want to revoke this template?"
          },
          "publish": {
            "title": "Publish template {{product}}",
            "description": "Are you sure you want to publish this template?"
          },
          "unsavedChanges": {
            "title": "Unsaved changes",
            "description": "You have unsaved changes. Are you sure you want to continue? Your changes will be lost."
          },
          "draft": {
            "tooltip": "Changes will apply to new materials"
          },
          "current": {
            "tooltip_one": "{{count}} active material",
            "tooltip_other": "{{count}} active materials"
          },
          "live": {
            "tooltip": "Changes will apply to existing materials"
          },
          "destroy": {
            "title": "Remove template {{name}}",
            "description": "Are you sure you want to remove or deactivate this template?"
          },
          "tooltip": {
            "required": "Field must be filled in before any form can be submitted.",
            "fieldUpdate": "Field visible for field user",
            "doubleEntryRequired": "When selected, repeat same input twice to confirm given value inside the second one",
            "includeEstimated": "Captures both an estimated value at start and a final confirmed value on completion.",
            "cumulative": "Check if the system should sum this field across entries in reports (e.g. total yards). Leave unchecked for descriptive fields (e.g. slump).",
            "showOnHotSeat": "Show this property value in the Hot Seat view for quick access during active work. You can choose only one property per material."
          }
        },
        "current": {
          "banner": "Last published version. View only mode.",
          "warning": "Last published version. View only mode."
        },
        "draft": {
          "banner": "Draft edit: Full editing capabilities. Changes will apply to new materials only.",
          "warning": "Draft edit: Full editing capabilities. Changes will apply to new materials only."
        },
        "live": {
          "banner": "Live edit: Quick changes only. Changes will apply to existing and new materials. Your current Draft will also be synced with published changes.",
          "warning": "Live edit Restriction: Some fields can only be modified in Draft Mode."
        }
      },
      "changes": {
        "fields": {
          "added": {
            "materialOption": "New property added"
          },
          "removed": {
            "materialOption": "Property removed"
          },
          "product": "Material name",
          "name": "Property name",
          "unit": "Unit name",
          "required": "Required",
          "showOnHotSeat": "Show on Hot Seat",
          "includeEstimated": "Estimated/final values",
          "calculationVariant": "Setup",
          "valueType": "Value type",
          "position": {
            "label": "Position",
            "up": "Moved up",
            "down": "Moved down"
          }
        },
        "info": "added",
        "danger": "removed",
        "warning": "modified"
      }
    },
    "globalWorkflows": {
      "title": "Workflow library"
    },
    "jobs": {
      "all": "All jobs",
      "archived": "Archived",
      "startDate": "start date",
      "followUp": "follow-up",
      "noJobs": "No jobs found with current filters",
      "date": {
        "open_one": "{{count}} open job",
        "open_other": "{{count}} open jobs",
        "completed_one": "{{count}} completed job",
        "completed_other": "{{count}} completed jobs",
        "total_one": "{{count}} job in total",
        "total_other": "{{count}} jobs in total"
      }
    },
    "jobProject": {
      "navbar": {
        "tabs": {
          "details": "Details",
          "permit": "Permit",
          "contacts": "Contacts",
          "notes": "Notes",
          "comments": "Comments ({{count}})"
        }
      },
      "startDate": "start date",
      "jobStartingDate": "Job starting date: {{date}}",
      "permitInfo": "Permit info",
      "hideDetails": "Hide details",
      "info": {
        "unassigned": "Unassigned",
        "title": "Job information",
        "jobName": "Job name",
        "jobDescription": "Job description",
        "jobAddress": "Address",
        "startDate": "Start date",
        "endDate": "End date",
        "projectCoordinator": "Project Coordinator",
        "projectManager": "Project Manager",
        "coordinates": "GPS coordinates",
        "builder": "Builder",
        "builderContact": "Builder's Contact",
        "locationDetails": "Subdivision or site",
        "hide": "Hide job details",
        "show": "Show job details",
        "permit": {
          "numbers": "{{workflowName}} permit info",
          "general": "General permit info",
          "workflows": "Workflows permit info",
          "add": "Add permit info",
          "dialog": {
            "title": "Add permit info",
            "description": "This permit info is shared across all workflows in this job.",
            "label": "General permit info",
            "placeholder": ""
          },
          "editDialog": {
            "title": "Edit permit info",
            "description": "This permit info is shared across all workflows in this job. Saving changes here updates it in every workflow.",
            "label": "General permit info",
            "placeholder": "",
            "removeTitle": "Remove permit info?",
            "removeDescription": "This permit info is shared across all workflows in this job. Removing it here removes it from all workflows in this job. This action cannot be undone."
          },
          "viewAll": "View all ({{count}})",
          "more": "+ {{count}} more"
        },
        "comments": {
          "allComments": "All comments",
          "viewAll": "View all ({{count}})",
          "empty": "Internal notes about this job for your office team."
        }
      },
      "actions": {
        "edit": "Edit"
      },
      "jobs": {
        "navbar": {
          "addWorkflow": "Add workflow",
          "more": "More",
          "moreJobs": "+ {{count}} more",
          "archived": "archived",
          "tooltip": {
            "archived": "Workflow is archived"
          },
          "menu": {
            "select": "select",
            "editWorkflow": "Edit workflow",
            "previewWorkflow": "Preview workflow",
            "archiveWorkflow": "Archive this workflow",
            "unarchiveWorkflow": "Unarchive this workflow",
            "removeWorkflow": "Remove this workflow",
            "reorderWorkflows": "Reorder workflows",
            "showArchived": "Show archived"
          }
        }
      }
    },
    "job": {
      "action": {
        "description": "Are you sure you want to {{action}} {{workflowName}}?",
        "tooltip": "You cannot {{action}} a job which has open external task schedules. Please remove them first:"
      },
      "cancel": {
        "title": "Remove {{workflowName}}",
        "action": "remove"
      },
      "snapshot": {
        "title": "Create a snapshot for {{workflowName}}",
        "action": "create snapshot"
      },
      "restore": {
        "title": "Restore saved snapshot for {{workflowName}}",
        "action": "restore snapshot"
      },
      "complete": {
        "title": "Archive {{workflowName}}",
        "action": "archive",
        "warning": "There are still missing subtasks in {{workflowName}}. Do you want to archive it regardless?",
        "lastWorkflow": {
          "description": "This is the last active workflow on this job. Archiving it will also archive the entire job. You can restore the job later from the Archived tab.",
          "warning": "The job will no longer appear on the All Jobs page.",
          "confirm": "Archive Workflow & Job"
        }
      },
      "removeTask": {
        "title": "Remove task",
        "description": "Are you sure you want to remove task {{name}}?"
      },
      "removeStage": {
        "title": "Remove stage",
        "description": "Are you sure you want to remove stage {{name}}?"
      },
      "missingSubtasks": "Missing subtasks",
      "addNew": "Add new",
      "addStage": "Add stage",
      "issue": "Reported job issue",
      "unarchive": {
        "title": "Unarchive {{workflowName}}",
        "action": "unarchive"
      },
      "integrationTooltip": "Ordered via Direct Concrete connection",
      "revertTask": "Are you sure you want to revert task {{name}}?",
      "revertSubtask": "Are you sure you want to revert subtask {{name}}?",
      "jobsList": "jobs list",
      "startDateTooltip": "start date",
      "lastScheduledDateTooltip": "last scheduled task date",
      "navbar": {
        "mainInformation": "Main information",
        "materials": "Materials",
        "inventory": "Inventory",
        "documents": "Documents",
        "questionary": "Layout checklist",
        "questionnaires": "Forms",
        "workProgress": "Work progress"
      },
      "info": {
        "notAdded": "Not added",
        "title": "Main information",
        "name": "Workflow name",
        "workflow": "Workflow template",
        "permitInfo": "Permit info",
        "workflowPermitInfo": "Permit info",
        "address": "Address",
        "projectCoordinator": "Project Coordinator",
        "builder": "Builder",
        "subdivision": "Subdivision or site",
        "superintendent": "Project Manager",
        "unassigned": "Unassigned",
        "assign": {
          "action": "Assign",
          "title": "Assign {{role}}",
          "success": "{{role}} has been assigned."
        },
        "followUpDate": "Follow-up date",
        "startDate": "Start date",
        "geolocalization": "GPS coordinates",
        "maps": {
          "retti": "Retti map",
          "google": "Google Maps",
          "copy": "Copy coordinates",
          "copied": "Copied"
        },
        "division": "Division",
        "previewLink": {
          "title": "Live job link",
          "description": "Want someone to see this job's progress?\nSend them this link. No login needed.",
          "visibility": "Anyone with the link can view it.",
          "copy": "Copy link",
          "copied": "Copied!",
          "send": "Send",
          "sent": "Live job link has been sent.",
          "preview": "See what they'll see",
          "back": "Back",
          "sendTitle": "Send live job link",
          "sendTo": "Send to",
          "emailPlaceholder": "Type an email",
          "pickContact": "Or pick a job contact:"
        },
        "builderSuperintendent": "Builder's Contact",
        "fieldNotes": "Field notes",
        "fieldNotesEmpty": "No field notes yet. Every field user on this workflow will see these notes.",
        "generalFieldNotesEmpty": "No field notes yet. Every field user on this job will see these notes.",
        "generalFieldNotes": "General field notes",
        "contacts": {
          "title": "External contacts",
          "createNew": "Create new contact",
          "add": {
            "action": "Add contact",
            "search": "Search by name, company, or role",
            "onThisJob": "On this job",
            "allContacts": "All contacts",
            "empty": "No contacts found",
            "error": "Contact could not be added"
          },
          "empty": {
            "title": "No external contacts yet",
            "description": "Add inspectors, building departments, or other contacts you'll need while scheduling this workflow.",
            "projectDescription": "Add inspectors, building departments, or other contacts you'll need while scheduling this job."
          },
          "tooltip": "Contact from global list"
        },
        "selectFile": "Select file",
        "doneTooltip": "This task was manually marked as done by the project coordinator",
        "inputs": {
          "estimatedQuantity": "Estimated quantity",
          "estimated": "{{name}} estimated",
          "finalQuantity": "Final quantity",
          "final": "{{name}} final"
        },
        "note": {
          "title": "Note: ",
          "create": "Add note",
          "update": "Edit note"
        },
        "comment": {
          "title": "Comment: ",
          "create": "Add comment",
          "update": "Edit comment"
        },
        "status": {
          "completed": "done",
          "scheduled": "scheduled",
          "rejected": "rejected",
          "schedule_request_sent": "requested",
          "in_progress": "in progress",
          "not_started": "not started",
          "ready_to_schedule": "ready to schedule",
          "cancelled": "cancelled",
          "on_hold": "on hold",
          "paused": "paused",
          "unconfirmed": "unconfirmed",
          "confirmed": "confirmed",
          "delivering": "delivering",
          "requested": "requested",
          "request_processed": "request processed",
          "to_schedule": "not scheduled",
          "incomplete": "incomplete",
          "draft": "draft",
          "no": "no",
          "yes": "yes"
        }
      },
      "latestNotes": {
        "title": "Comments",
        "seeAll": "See all comments ({{count}})",
        "empty": {
          "title": "No comments yet",
          "description": "Internal notes about this workflow for your office team."
        },
        "dialog": {
          "title": "All comments"
        }
      },
      "documents": {
        "title": "Documents",
        "action": "Add new document",
        "other": "Other",
        "table": {
          "document": "document",
          "fileName": "file name",
          "size": "size",
          "type": "type",
          "required": "required",
          "updatedAt": "modified at",
          "creator": "uploaded by"
        }
      },
      "materials": {
        "title": "Materials",
        "action": "Add new material",
        "concreteOrderTooltip": "These fields are part of the field user's submissions, and completing them will close the field user's subtasks",
        "estimatedRemoveAlert": "Are you sure you want to remove all Estimated Values from {{item}}",
        "finalRemoveAlert": "Are you sure you want to remove all Final Values from {{item}}? Removing them will change the subtask statuses.",
        "estimated": "Estimated",
        "doubleEntryRequired": "x2",
        "fieldUpdate": "Field update",
        "estimatedFullName": "{{name}} estimated:",
        "finalFullName": "{{name}} final:",
        "final": "Final",
        "required": "required",
        "notRequired": "not required",
        "table": {
          "product": "product name",
          "estimatedQuantity": "estimated quantity",
          "estimatedSlump": "estimated slump",
          "psi": "psi",
          "finalQuantity": "final quantity",
          "finalSlump": "final slump",
          "quantity": "quantity",
          "unit": "unit",
          "lastModified": "last modified",
          "modifiedAt": "modified at",
          "modifiedBy": "modified by"
        }
      },
      "inventory": {
        "title": "Inventory",
        "summary": {
          "title": "Summary",
          "requested": "Requested",
          "onTheWay": "On the way",
          "atSite": "At site",
          "stillNeeded": "Still needed"
        },
        "table": {
          "group": "group",
          "description": "description",
          "needed": "needed",
          "requested": "requested",
          "onTheWay": "on the way",
          "atSite": "at site",
          "stillNeeded": "still needed"
        },
        "dialog": {
          "title": "Item list",
          "description": "List the quantity of materials required.",
          "table": {
            "name": "name",
            "description": "description",
            "needed": "needed"
          }
        },
        "addItem": "Add item",
        "addToTheList": "Add to the list",
        "locked": "Can't be removed - item is already requested, on the way or at site",
        "removeDialog": {
          "description_one": "Are you sure you want to remove {{count}} item from the inventory list?",
          "description_other": "Are you sure you want to remove {{count}} items from the inventory list?"
        },
        "action": "View full item list"
      },
      "days": {
        "calendar": "Show schedule calendar",
        "allDays": "All days ({{count}})",
        "status": {
          "scheduled": "Scheduled",
          "draft": "Draft",
          "overdue": "Incomplete",
          "completed": "Completed"
        }
      },
      "addTaskSchedule": {
        "title": "Schedule {{name}}",
        "withoutSchedule": "Add without scheduling",
        "days": {
          "label": "Days",
          "hint": "Click a day, then another to pick a range. Click a day inside the range to skip it.",
          "summary_one": "1 day: {{range}}",
          "summary_other": "{{count}} days: {{range}}",
          "skipped_one": "1 skipped",
          "skipped_other": "{{count}} skipped",
          "empty": "No days picked yet",
          "clear": "Clear"
        },
        "team": {
          "label": "Field user",
          "placeholder": "No team",
          "noTeam": "Leave empty to schedule without a team.",
          "defaultCrew": {
            "label": "Include default crew members",
            "empty": "No default crew members set"
          },
          "defaultEquipment": {
            "label": "Include default equipment",
            "empty": "No default equipment set"
          }
        }
      }
    },
    "jobPreview": {
      "contacts": {
        "title": "Contacts",
        "coordinator": "Project coordinator",
        "superintendent": "Project manager",
        "builderSuperintendent": "builder's contact"
      },
      "workProgress": {
        "title": "Work progress"
      }
    },
    "foreman": {
      "files": {
        "title": "Files",
        "heading": {
          "documents": "Documents",
          "other": "My uploaded files",
          "otherDisabled": "Uploaded files"
        }
      },
      "schedule": {
        "crew": {
          "title": "Crew",
          "assignedLead": "Assigned lead",
          "assignedMembers": "Crew",
          "assignedAsCrew": "As crew member"
        },
        "equipment": {
          "title": "Equipment",
          "assignedLead": "Assigned lead",
          "assignedMembers": "Equipment"
        },
        "workProgress": "Work progress",
        "documents": "Documents",
        "materials": {
          "title": "Materials",
          "estimated": "Estimated",
          "final": "Final",
          "value": "Value",
          "quantity": "quantity",
          "slump": "slump",
          "psi": "PSI"
        },
        "yourTasks": "Your tasks",
        "tasks": "Tasks",
        "revert": "select tasks to revert",
        "issues": {
          "title": "Reported job issues",
          "type": {
            "critical": "blocker",
            "resolved": "resolved"
          }
        },
        "notes": {
          "more": "Show more",
          "less": "Show less"
        }
      },
      "missing": "missing",
      "issue": {
        "dialog": {
          "title": "Report job issue"
        }
      },
      "scheduledWithoutTeam": "Without team"
    },
    "workload": {
      "displayOptions": {
        "options": {
          "jobPreview": {
            "taskName": "Task name",
            "jobName": "Job name",
            "jobAddress": "Job address",
            "jobBuilder": "Builder name",
            "jobNotes": "Task note",
            "jobPermitNumber": "Permit info",
            "jobSubdivision": "Subdivision or site",
            "jobInventory": "Inventory"
          },
          "calendarOptions": {
            "title": "Calendar options"
          },
          "schedulingSettings": {
            "title": "Scheduling settings",
            "enableMagnetMode": "Enable magnet mode",
            "hideSchedulerSidebar": "Hide scheduler sidebar",
            "hideMissingSpecialties": "Hide “Missing Specialties” warning"
          },
          "project": {
            "title": "Job details",
            "projectName": "Job name",
            "projectAddress": "Job address",
            "projectDescription": "Job description",
            "projectBuilder": "Builder"
          },
          "jobCardOptions": {
            "title": "Job view settings"
          },
          "job": {
            "title": "Workflow details",
            "taskName": "Task name",
            "jobName": "Workflow name",
            "jobAddress": "Workflow address",
            "jobBuilder": "Builder",
            "taskNotes": "Task notes",
            "jobPermitNumber": "Permit info",
            "jobSubdivision": "Subdivision or site",
            "jobInventory": "Inventory",
            "taskCrewCount": "Task crew count",
            "jobRelatedTasks": "Related tasks"
          },
          "density": {
            "title": "Density",
            "groupAllTasksByStage": "Group all tasks by stage",
            "showAllScheduledTasks": "Show all scheduled tasks"
          },
          "weekends": {
            "title": "Weekends",
            "saturday": "Saturday",
            "sunday": "Sunday"
          }
        },
        "tooltip": {
          "density": {
            "showAllScheduledTasks": "Shows every task in a cell when enabled. When off, limits visible tasks and keeps the calendar at a fixed height."
          },
          "schedulingSettings": {
            "enableMagnetMode": "Drag and drop tasks freely without opening the scheduler pop-up window"
          }
        },
        "preview": {
          "permitNumber": "Permit",
          "subdivision": "Subdivision or site"
        }
      },
      "title": "Calendar",
      "previousWeek": "Previous week",
      "thisWeek": "This week",
      "nextWeek": "Next week",
      "more": "+{{count}} more",
      "readyToSchedule": {
        "title": "Ready to schedule",
        "drop": "Drag and drop here to unschedule",
        "days": "{{count}}d",
        "tooltip_one": "Waiting {{count}} day to be scheduled",
        "tooltip_other": "Waiting {{count}} days to be scheduled",
        "unscheduled_one": "{{count}} Unscheduled Task",
        "unscheduled_other": "{{count}} Unscheduled Tasks",
        "addTask": "Add task",
        "internalTask": "Internal Task",
        "externalTask": "External Task"
      },
      "status": {
        "draft": "draft",
        "approved": "scheduled",
        "completed": "done",
        "pending": "requested",
        "rejected": "rejected",
        "requested": "requested"
      },
      "inventory": {
        "completedAtSite": "Items still at the site",
        "stillNeeded": "Items still needed",
        "allDelivered": "All items delivered",
        "noItemsRequested": "No items requested",
        "allItemsTaken": "All items taken"
      },
      "collapsedDay": {
        "expand": "Show {{day}}",
        "collapse": "Collapse {{day}}",
        "hiddenSchedules_one": "{{count}} hidden schedule",
        "hiddenSchedules_other": "{{count}} hidden schedules"
      },
      "hiddenRecords": {
        "day_one": "day",
        "day_other": "days",
        "tasks_one": "{{count}} task hidden across {{daysCount}} {{daysLabel}}",
        "tasks_other": "{{count}} tasks hidden across {{daysCount}} {{daysLabel}}",
        "resource_one": "resource",
        "resource_other": "resources",
        "schedules_one": "{{count}} schedule hidden across {{resourcesCount}} {{resourcesLabel}}",
        "schedules_other": "{{count}} schedules hidden across {{resourcesCount}} {{resourcesLabel}}",
        "showHidden": "Show hidden",
        "hideHidden": "Hide"
      }
    },
    "inventory": {
      "addNewRoute": "Add new route",
      "editSitesQuantities": "Edit sites quantities",
      "dropdown": {
        "allAvailable": "Add all available",
        "neededOnly": "Add needed only"
      },
      "routes": {
        "noTeam": "No team",
        "points": {
          "pick_up": "Picked up",
          "drop_off": "Dropped off",
          "requested": "Requested"
        },
        "empty": "route is empty",
        "selectRoute": "Select route",
        "clearAll": "Are you sure you want to clear all deliveries in this route?",
        "missing": "missing load",
        "remaining": "remaining load",
        "point": {
          "eta": "ETA",
          "scheduled": "scheduled",
          "dropOff": "drop off",
          "pickUp": "pick up",
          "stop": "stop",
          "setUpBlankets": "the team should set up blankets",
          "miles_one": "mile",
          "miles_other": "miles",
          "mins_one": "min",
          "mins_other": "mins"
        }
      },
      "requests": {
        "title": "Needed",
        "table": {
          "name": "name",
          "stillNeeded": "still needed"
        }
      },
      "available": {
        "title": "Available",
        "table": {
          "name": "name",
          "availability": "availability",
          "atSite": "at site",
          "status": {
            "header": "Status",
            "options": {
              "available": "Available",
              "notAvailable": "N/A"
            }
          }
        }
      },
      "title": {
        "requested": "Needed",
        "available": "Available"
      },
      "points": {
        "eta": "ETA",
        "scheduled": "scheduled",
        "dropOff": "drop off",
        "pickUp": "pick up",
        "stop": "stop",
        "setUpBlankets": "the team should set up blankets",
        "miles_one": "mile",
        "miles_other": "miles",
        "mins_one": "min",
        "mins_other": "mins",
        "tooltip": {
          "success": "Bar is green because 100% of required items are covered",
          "info": "Bar is blue because there are still needed items",
          "covered": "already covered",
          "needed": "still needed",
          "pickUp": {
            "value": "of needed items covered in this pick up",
            "extra": "extra items will be picked up"
          },
          "dropOff": {
            "value": "in this drop off",
            "extra": "extra items will be delivered"
          }
        },
        "warning": {
          "multiload": "Possible overload",
          "hidden": "Complete the route setup in order to save it"
        }
      },
      "table": {
        "name": "name",
        "item": "description",
        "needed": "needed",
        "ordered": "ordered",
        "requested": "requested",
        "atSite": "at site",
        "stillNeeded": "still needed",
        "items": "items",
        "sets": "sets",
        "availability": "availability",
        "available": "available",
        "distance": "distance",
        "miles_one": "mile",
        "miles_other": "miles",
        "status": {
          "header": "Status",
          "options": {
            "available": "Available",
            "notAvailable": "N/A"
          }
        }
      },
      "dialog": {
        "quantities": {
          "title": "Edit quantities",
          "description": "List the quantity of materials required.",
          "form": {
            "select": "Select location"
          },
          "table": {
            "name": "Name",
            "description": "Description",
            "atSite": "At site"
          }
        },
        "customAdd": {
          "tooltip": "More items scheduled than required",
          "table": {
            "description": "description",
            "needed": "needed",
            "ordered": "ordered",
            "available": "available",
            "requested": "requested",
            "availableAtSite": "available at site",
            "setUpBlankets": "the team should set up blankets",
            "otherAvailableItems": "other available items",
            "remainingItems": "remaining items"
          },
          "summary": {
            "title": "Load",
            "weightGroups": {
              "cages": "Cages",
              "blankets": "Blankets",
              "braceCage": "Brace cage",
              "scaffoldTrailers": "Scaffold trailers"
            }
          }
        },
        "removePair": {
          "title": "Delete this delivery",
          "description": "Are you sure you want to permanently remove all stops at this delivery?"
        },
        "confirmation": {
          "both": {
            "title": "Confirmation",
            "notAvailableItems": "items not available at selected pickup location",
            "additionalItems": "additional items in current pickup"
          },
          "reduced": {
            "title": "Request size will be reduced",
            "description": {
              "first": "Selected pick up location has less items than needed at drop off location.",
              "second": "Only available items will be delivered."
            }
          },
          "additionalItems": {
            "title": "Additional items at pick up location",
            "description": "Selected pick up location has additional items (not needed at drop off).",
            "radio": {
              "label": "Choose how to manage additional items:",
              "options": {
                "skipExcess": "Do not take any additional items",
                "includeAllInCurrentDrop": "Take all and leave at current drop off location",
                "createExtraDrop": "Take all and add a new stop for additional items"
              }
            }
          }
        },
        "preview": {
          "multiload": "More than one transport needed"
        }
      }
    },
    "map": {
      "cluster": "Cluster of {{count}} markers",
      "noCoords": "No coordinates",
      "error": {
        "title": "Map could not be loaded",
        "description": "Google Maps failed to load. The job list is still available.",
        "retry": "Try again"
      }
    },
    "questionnaires": {
      "answered": "questions answered",
      "changelog": {
        "title": "Changelog",
        "changes": {
          "value": {
            "message": "sets answer to",
            "no": "NO",
            "yes": "YES",
            "n/a": "N/A"
          },
          "images": {
            "add": "uploaded photo",
            "add_other": "uploaded {{count}} photos",
            "remove": "removed photo"
          }
        }
      },
      "table": {
        "yes": "Yes",
        "no": "No",
        "notAssigned": "N/A"
      }
    },
    "dashboards": {
      "preset": "preset",
      "column": "column",
      "noItems": "No jobs found with selected filters",
      "search": "Find columns to add:",
      "details": "Job details",
      "stage": "Stage",
      "task": "Task",
      "subtask": "Subtask",
      "label": "Label",
      "source": {
        "title": "Include data from",
        "options": {
          "scheduled": "Active jobs",
          "completed": "Archived jobs",
          "all": "All jobs"
        }
      },
      "tooltip": {
        "clear": "Clear the loaded preset and start building from scratch",
        "sort": "Sort",
        "filter": "Filter",
        "settings": "Settings",
        "pin": "Pin",
        "remove": "Remove"
      },
      "attribute": {
        "jobIdentifier": "Job",
        "address": "Address",
        "name": "Name",
        "workflowName": "Workflow name",
        "workflows.workflowName": "Workflow template name",
        "workflowAddress": "Workflow address",
        "workflowDivision": "Workflow division",
        "permitNumber": "Permit info",
        "subdivision": "Subdivision or site",
        "geolocalization": "GPS coordinates",
        "startDate": "Start date",
        "createdAt": "Workflow creation date",
        "followUpDate": "Follow-up date",
        "jobDescription": "Description",
        "coordinators.assignedUser": "Project Coordinator",
        "superintendents.assignedUser": "Project Manager",
        "builders.assignedUser": "Builder",
        "builderSuperintendents.assignedUser": "Builder's Contact",
        "options.estimatedQuantity": "Materials estimated quantity",
        "options.finalQuantity": "Materials final quantity",
        "status": "Status",
        "crewRequirements.requirement": "Crew requirements",
        "schedules.scheduleDate": "Schedule date",
        "schedules.scheduleDay": "Schedule day",
        "schedules.scheduleTime": "Schedule time",
        "schedules.assignedUser": "Field user/contact",
        "schedules.assignedCrewUsers": "Assigned crew members + roles",
        "schedules.assignedCrewUsersNameOnly": "Assigned crew members",
        "schedules.assignedEquipment": "Assigned equipment",
        "notes.content": "Note",
        "projectNotes.content": "Field notes",
        "workflowNotes.content": "Workflow field notes",
        "files.filename": "Files",
        "statusesHistory.toSchedule.ago": "Days since 'to schedule'",
        "statusesHistory.toSchedule.date": "Moved to 'to schedule' on",
        "statusesHistory.readyToSchedule.ago": "Days since 'ready to schedule'",
        "statusesHistory.readyToSchedule.date": "Moved to 'ready to schedule' on",
        "statusesHistory.scheduled.ago": "Days since 'scheduled'",
        "statusesHistory.scheduled.date": "Moved to 'scheduled' on",
        "statusesHistory.inProgress.ago": "Days since 'in progress'",
        "statusesHistory.inProgress.date": "Moved to 'in progress' on",
        "statusesHistory.completed.ago": "Days since 'completed'",
        "statusesHistory.completed.date": "Moved to 'completed' on"
      },
      "select": {
        "placeholder": "Saved views",
        "options": {
          "create": "Save view",
          "update": "Save changes",
          "remove": "Remove view"
        }
      },
      "dialogs": {
        "preset": {
          "create": "Save view",
          "update": "Update view",
          "checkbox": "Set as default view"
        },
        "column": {
          "details": {
            "create": "Add columns",
            "update": "Edit column {{name}}"
          },
          "settings": {
            "title": "Column settings",
            "switch": "Show data Source Label in cells",
            "options": {
              "title": "Include in data source label",
              "stage": "Stage name",
              "task": "Task name",
              "subtask": "Subtask name"
            }
          }
        }
      }
    },
    "specialties": {
      "title": "Specialties",
      "dialog": {
        "create": "Create new specialty",
        "update": "Edit specialty",
        "deactivate": {
          "title": "Deactivate specialty {{name}}",
          "description": "Are you sure you want to deactivate this specialty?"
        },
        "reactivate": {
          "title": "Reactivate specialty {{name}}",
          "description": "Are you sure you want to reactivate this specialty?"
        }
      },
      "generated": "Auto-generated",
      "usedIn": "Used in",
      "status": {
        "active": "active",
        "notUsed": "not used",
        "neverUsed": "never used",
        "archived": "deactivated"
      }
    },
    "divisions": {
      "title": "Divisions",
      "item": "division",
      "dialog": {
        "create": "Create new division",
        "update": "Edit division"
      }
    },
    "customSettings": {
      "title": "Settings",
      "names": {
        "builder_job_notification_disabled": "Disable job notifications for builders",
        "external_contacts_text_message_disabled": "Disable text messages to external contacts",
        "external_schedule_mark_as_confirmed": "External tasks should have 'Mark as confirmed' selected by default",
        "internal_schedule_mark_as_confirmed": "Internal tasks should have 'Mark as confirmed' selected by default",
        "other_jobs_tab_disabled": "Disable 'Other jobs' tab for field users",
        "others_schedules_full_access": "Full access to other users' schedules",
        "ribbon_intervals": "Scheduler time intervals",
        "scheduler_ending_hour": "Scheduler ending hour",
        "scheduler_starting_hour": "Scheduler starting hour",
        "scheduler_tray_enabled": "Enable scheduler tray",
        "on_deck_view_disabled": "Disable 'On deck' view",
        "hot_seat_view_disabled": "Disable 'Hot seat' view",
        "inventory_module_disabled": "Disable 'Inventory module'",
        "route_pick_up_task_name": "Route pick-up task name",
        "route_drop_off_task_name": "Route drop-off task name",
        "mcp_access_enabled": "Enable AI assistant access (MCP)"
      },
      "descriptions": {
        "route_pick_up_task_name": "Applies only to tasks created after the change; existing route tasks keep their current name.",
        "route_drop_off_task_name": "Applies only to tasks created after the change; existing route tasks keep their current name.",
        "mcp_access_enabled": "Lets this company's users connect AI assistants such as Claude to read their Retti data. Turning it off cuts off existing connections straight away."
      }
    },
    "globalItems": {
      "title": "Inventory",
      "item": "item",
      "noGroup": "No group",
      "itemsCount_one": "{{count}} item",
      "itemsCount_other": "{{count}} items",
      "inUse": "In use",
      "usage": "Used in {{inventory}} inventory items and {{orders}} route order items",
      "empty": "No inventory items yet",
      "table": {
        "name": "Name",
        "description": "Description",
        "weightGroup": "Weight group",
        "weight": "Weight",
        "unloadingTime": "Unloading time",
        "unpackingTime": "Unpacking time",
        "status": "Status"
      },
      "weightGroups": {
        "cages": "Cages",
        "blankets": "Blankets",
        "braceCage": "Brace cage",
        "scaffoldTrailers": "Scaffold trailers"
      },
      "tooltip": {
        "itemInUse": "Item is used in inventory or routes and can't be deleted",
        "groupInUse": "Group has items in use and can't be deleted"
      },
      "dialog": {
        "create": "Create new global item",
        "update": "Edit global item",
        "lockedHint": "Can't be changed – item is already used in inventory or routes"
      },
      "groups": {
        "title": "Groups",
        "item": "group",
        "empty": "No groups yet",
        "removeItems_zero": "This group has no items.",
        "removeItems_one": "The {{count}} item in this group will be deleted too.",
        "removeItems_other": "All {{count}} items in this group will be deleted too.",
        "dialog": {
          "create": "Create new group",
          "update": "Rename group"
        }
      },
      "errors": {
        "notAuthorized": "You don't have permission",
        "itemInUse": "Item is in use and can't be deleted",
        "groupInUse": "Group has items in use and can't be deleted",
        "notFound": "Record not found",
        "default": "Something went wrong. Please try again."
      }
    }
  },
  "hotSeat": {
    "task": {
      "completed": "Task {{type}} completed"
    },
    "empty": "No team"
  },
  "fullDaySwitch": {
    "outOfScopeHint": "Some schedules are not visible within given time range"
  },
  "settings": {
    "label": {
      "hotSeat": "When events are close to each other",
      "workload": {
        "views": "Additional views",
        "dragAndDrop": "Drag and Drop action"
      }
    },
    "checkbox": {
      "sidebar": "Show sidebar",
      "unassigned": "Show unassigned",
      "skipScheduler": "Skip scheduler",
      "collapse": "Enable jobs collapsing"
    }
  },
  "errors": {
    "stage_not_optional": "Cannot remove stage that is not manually added!",
    "stage_is_in_progress": "Cannot remove stage that is in progress!",
    "download": "An error occurred during file download! Try again later.",
    "invalidFileType": "File type is invalid! Try again with correct file.",
    "cannot_be_empty": "An error occurred! (cannot_be_empty)",
    "number_ids_not_unique": "Permit info must be unique.",
    "cannot_be_blank": "Fill in the required information before proceeding. (cannot_be_blank)",
    "invalid_role": "Verify the assigned role meets the requirements. (invalid_role)",
    "invalid": "Check and ensure that the format is correct. (invalid)",
    "invalid_format": "Check and ensure that the size or format of file is correct. (invalid_format)",
    "greater_or_equal": "Ensure the provided geolocation format is correct. (greater_or_equal)",
    "less_or_equal": "Ensure the provided geolocation format is correct. (less_or_equal)",
    "not_included": "An error occurred! (not_included)",
    "invalid_task_status": "Cannot schedule task with this status!",
    "overlapping_schedules": "Schedules cannot overlap for the field user. (overlapping_schedules)",
    "cannot_be_before_starts_at": "Schedule has to end after it's start time. (cannot_be_before_starts_at)",
    "cannot_be_in_past": "Schedule cannot start in the past. (cannot_be_in_past)",
    "invalid_e164_phone": "Incorrect phone number format. (invalid_e164_phone)",
    "existing_active_schedule": "Schedule already exist for this task. (existing_active_schedule)",
    "not_assigned_to_task_job": "Ensure the contact belongs to the same job as the task. (not_assigned_to_task_job)",
    "no_main_contact": "Please add main contact for the task. (no_main_contact)",
    "invalid_task_schedule_type": "An error occurred! (invalid_task_schedule_type)",
    "cannot_be_on_different_day": "Adjust the schedule to be within the same day. (cannot_be_on_different_day)",
    "cannot_destroy_user": "Cannot remove user with assigned jobs or tasks! (cannot_destroy_user)",
    "dependent_schedule": "Cannot schedule dependent task. (dependent_schedule)",
    "task_cannot_be_completed": "Cannot override already completed task. (task_cannot_be_completed)",
    "cannot_revert_force_complete": "Cannot override revert this task. (cannot_revert_force_complete)",
    "contact_already_assigned_to_task": "Contact is already assigned to a task. (contact_already_assigned_to_task)",
    "max_size_error": "File size is too big! (max_size_error)",
    "min_size_error": "File size is too small! (min_size_error)",
    "invalid_builder_superintendent": "Builder contact has to be assigned to selected builder. (invalid_builder_superintendent)",
    "cannot_destroy_builder_superintendent": "Cannot remove contact with assigned jobs! (cannot_destroy_builder_superintendent)",
    "invalid_token": "An error occurred! (invalid_token)",
    "cannot_cancel_job": "Cannot remove job with any progress started! (cannot_cancel_job)",
    "cannot_destroy_assigned_material": "Cannot remove subtask related materials. (cannot_destroy_assigned_material)",
    "cannot_destroy_builder": "Cannot remove builder with active jobs! (cannot_destroy_builder)",
    "email_taken": "Email is already in use!",
    "invalid_referable_type": "An error occurred when creating a note. (invalid_referable_type)",
    "missing_record": "An error occurred when creating a note. (missing_record)",
    "open_external_tasks": "In order to close the job, you have to close all external tasks first. (open_external_tasks)",
    "existing_webpush": "An error occurred! (existing_webpush)",
    "missing_task_or_invalid_task_schedule_type": "An error occurred! (missing_task_or_invalid_task_schedule_type)",
    "job_not_completed": "An error occurred! (job_not_completed)",
    "can_have_only_one_note": "An error occurred! (can_have_only_one_note)",
    "invalid_usage_type": "An error occurred! (invalid_usage_type)",
    "only_job_can_has_office_notes": "An error occurred! (only_job_can_has_office_notes)",
    "cannot_destroy_resolved_issue": "Cannot remove resolved Job Issue! (cannot_destroy_resolved_issue)",
    "company_id_or_job_id_or_project_id_cannot_be_blank": "An error occurred! (company_id_or_job_id_or_project_id_cannot_be_blank)",
    "cannot_destroy_company_with_assigned_contacts": "Cannot remove company with existing contacts (cannot_destroy_company_with_assigned_contacts)",
    "contact_already_exists_in_given_job": "Contact already added to this job! (contact_already_exists_in_given_job)",
    "missing_required_tasks": "Missing required tasks to schedule this task! (missing_required_tasks)",
    "missing_stage": "An error occurred! (missing_stage)",
    "missing_config_file": "An error occurred! (missing_config_file)",
    "task_materials_changed": "An error occurred! (task_materials_changed)",
    "only_job_or_warehouse_allocation": "An error occurred! (only_job_or_warehouse_allocation)",
    "greater_than_zero": "An error occurred! (greater_than_zero)",
    "cannot_change_scheduled_route": "Can't add new stops to already scheduled route! (cannot_change_scheduled_route)",
    "cannot_change_details_for_scheduled_route": "Can't change inventory numbers for already scheduled route! (cannot_change_details_for_scheduled_route)",
    "cannot_destroy_inventory_item": "Can't remove this item! (cannot_destroy_inventory_item)",
    "cannot_destroy_route": "Can't remove this route! (cannot_destroy_route)",
    "item_already_added": "An error occurred! (item_already_added)",
    "missing_starting_time": "Route needs at least one timing to be set! (missing_starting_time)",
    "cannot_pick_up_all_items_from_yard": "Can't add all items from the yard location! (cannot_pick_up_all_items_from_yard)",
    "cannot_create_point_without_route": "An error occurred! (cannot_create_point_without_route)",
    "cannot_create_point_without_order_items": "An error occurred! (cannot_create_point_without_order_items)",
    "cannot_destroy_routes_point": "Can't remove this point! (cannot_destroy_routes_point)",
    "cannot_edit_route": "Can't edit route that has already started! (cannot_edit_route)",
    "greater_or_equal_point": "An error occurred! (greater_or_equal)",
    "invalid_construction_type": "An error occurred! (invalid_construction_type)",
    "cannot_reschedule_task": "An error occurred! (cannot_reschedule_task)",
    "only_one_value_allowed": "An error occurred! (only_one_value_allowed)",
    "cannot_add_another_answer": "An error occurred! (cannot_add_another_answer)",
    "select_only_one_option": "An error occurred! (select_only_one_option)",
    "only_one_custom_items_set_available": "An error occurred! (only_one_custom_items_set_available)",
    "TOO_SHORT": "Invalid phone number. Please check if number you've entered is correct (TOO_SHORT)",
    "TOO_LONG": "Invalid phone number. Please check if number you've entered is correct (TOO_LONG)",
    "INVALID_BUT_POSSIBLE": "Invalid phone number. Please check if number you've entered is correct (INVALID_BUT_POSSIBLE)",
    "INVALID_COUNTRY_CODE": "Invalid phone number. Please check the country prefix (INVALID_COUNTRY_CODE)",
    "INVALID_LENGTH": "Invalid phone number. Please check if number you've entered is correct (INVALID_LENGTH)",
    "NOT_A_NUMBER": "Invalid phone number. Please check if number you've entered is correct (NOT_A_NUMBER)",
    "invalid_time_12": "Invalid 12h time format (hh:mm am/pm)",
    "invalid_time_24": "Invalid 24h time format (hh:mm)",
    "no_questionary_created": "There is no questionary in current job.",
    "only_task_can_has_quick_note": "An error occurred! (only_task_can_has_quick_note)",
    "only_total_numbers": "An error occurred! (only_total_numbers)",
    "mismatched_tenant": "An error occurred! (mismatched_tenant)",
    "cannot_change_self_role": "Cannot change your own admin permissions! (cannot_change_self_role)",
    "user_email_taken": "User with that email already exists! (user_email_taken)",
    "slug_taken": "Tenant with this slug already exists! (slug_taken)",
    "cannot_reactivate_active_tenant": "An error occurred! (cannot_reactivate_active_tenant)",
    "missing_default_workflow_template": "An error occurred! (missing_default_workflow_template)",
    "cannot_edit_published_workflow": "An error occurred! (cannot_edit_published_workflow)",
    "account_disable": "Your company’s account has been deactivated. Please contact your administrator for more details.",
    "not_acceptable_extension_type": "An error occurred! (not_acceptable_extension_type)",
    "non_exist": "An error occurred! (non_exist)",
    "missing_tenant_published_workflow": "An error occurred! (missing_tenant_published_workflow)",
    "only_task_or_subtask_allocation": "An error occurred! (only_task_or_subtask_allocation)",
    "missing_workflow_task_error": "An error occurred! (missing_workflow_task_error)",
    "missing_workflow_error": "An error occurred! (missing_workflow_error)",
    "integration_missing": "An error occurred! (integration_missing)",
    "invalid_characters": "Invalid slug. Use only a-z (lowercase), 0-9, _ , and -",
    "missing_phone_number_for": "An error occurred! (missing_phone_number)",
    "invalid_task_confirmation": "An error occurred! (invalid_task_confirmation)",
    "material_missing": "An error occurred! (material_missing)",
    "error_on_workflow_questionnaires": "Missing form contents! (error_on_workflow_questionnaires)",
    "cannot_destroy_task": "Cannot remove task! (cannot_destroy_task)",
    "cannot_edit_not_owned_preset": "Cannot edit this preset! (cannot_edit_not_owned_preset)",
    "at_least_one_route_specialty_required": "At least one route specialty must be selected!",
    "crew_members_assigned_to_another_field_user": "At least one of selected crew members already belongs to crew!",
    "already_added_permit_number": "An error occurred! (already_added_permit_number)",
    "replacement_tag_not_found": "Replacement tag not found. Please select a valid tag.",
    "already_created": "A tag with this name already exists.",
    "route_stage_cannot_be_optional": "A route pick up / drop off stage cannot be optional.",
    "construction_stage_cannot_be_optional": "The stage starting construction cannot be optional.",
    "error_on_workflow_route_stages": "Set both a route pick up and a route drop off stage (they can be the same stage), or neither. Optional stages cannot be used.",
    "error_on_workflow_construction_stage": "Only one stage can start construction, and it cannot be optional.",
    "error_on_workflow_billing_task": "Only one task in the workflow can be the billing task.",
    "missing_route_stage": "These jobs have no route pick up / drop off stage in their workflow: {{details}}",
    "request_failed": "Couldn't save. Check your connection and try again.",
    "form_submit_failed": "Couldn't save. Close the form and try again.",
    "form_hidden_errors": "Couldn't save. Close the form and try again. ({{details}})",
    "questionnaire_not_attachable": "A form can only be attached to a task with the \"Form\" type (questionnaire_not_attachable)",
    "questionnaire_in_use": "This form is still used by a task or subtask, so it can't be deleted (questionnaire_in_use)"
  },
  "queryError": {
    "title": "Couldn't load data",
    "description": "The connection is slow or unavailable. Check your internet and try again."
  }
}
